<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div v-if="routeLoading" class="load-wrap" style="min-height: 100vh">

        </div>
        <div v-else class="main-wrap">
          <div class="settings-header">
            <span>
              Process Client Payment for Business Type: Service & Method of Accounting: Cash
            </span>
            <div>
              <span style="margin-right: 20px; font-size: 14px;">Recording Journal - Cash Receipts</span>
              <el-button size="mini" @click="() => $router.push(`/journal-and-gl?companyId=${$route.query.companyId}&tab=cashReceipts`)">Journals</el-button>
            </div>
          </div>
          <el-form
              label-position="left"
              ref="form"
              :model="form"
              :rules="rules"
              :disabled="disabledForm"
              class="form"
              size="mini">
            <el-card class="card">
              <div class="source-wrapper">
                <div class="source">
                  <h4 style="margin: 0px;">Source Document</h4>
                  <el-button type="primary" size="mini" @click="() => $refs.file.click()"><i class="el-icon-upload"></i>Source Documents</el-button>
                  <input :disabled="disabledForm" ref='file' v-show="false" @change="handleFilePreview" id="file" name="myFile" type="file">
                </div>
                <div @click="filesOpened = !filesOpened">
                  <i v-if="!filesOpened" class="el-icon-arrow-right tf-icon"></i>
                  <i v-else class="el-icon-arrow-down tf-icon"></i>
                </div>
              </div>
              <div v-if="filesOpened" style="margin-top: 40px; max-width: 50%;" class="source-content">
                <img v-if="imgPreviewSrc" style="width: 100%;" class="preview-banner" :src="imgPreviewSrc" alt="preview-banner">
              </div>
            </el-card>
            <el-card class="card">
              <h4 style="margin-top: 0px;">Client Details</h4>
              <el-row :span="24" :gutter="20">
                <el-col :span="6">
                  <el-form-item
                      class="label-without-start"
                      label-width="134px"
                      prop="clientId"
                      label="Client *">
                    <el-select
                        filterable
                        no-data-text="no date"
                        class="select"
                        placeholder="Type or Select Client"
                        v-model="form.clientId"
                        @change="changeClient"
                    >
                      <el-option
                          v-for="item in clientList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-button type="primary" size="mini" :disabled="disabledForm" plain style="width: 100%" @click="addClientOpenModal">{{$t('clients_btn_add')}}</el-button>
                </el-col>
              </el-row>

              <!-- s -->
               <el-row :gutter="40">
                <el-col :span="8" :offset="0">
                  <el-form-item label-width="134px" prop="clientTin" label="Client TIN">
                    <el-input v-model="form.clientTin" readonly placeholder="Client TIN" style='width: 100%;'>
                    </el-input>
                  </el-form-item>

                  <el-form-item label-width="134px" prop="typeOfBusiness" label="Type of Business">
                    <el-input v-model="form.typeOfBusiness" readonly placeholder="Type of Business">
                    </el-input>
                  </el-form-item>

                  <el-form-item label-width="134px" prop="paymentTerms" label="Payment Terms">
                    <el-input v-model="form.paymentTerms" readonly placeholder="Payment Terms">
                    </el-input>
                  </el-form-item>

                  <el-form-item label-width="134px" prop="currency" label="Currency">
                    <span v-if="form.currency"> {{ form.currency }} </span>
                  </el-form-item>

                  <el-form-item label-width="174px" prop="clResult" label="Under/Over Pmt Balance">
                    <div style="display: flex; align-items: center; gap: 4px;">
                      <money v-model="form.clResult" v-bind="money" :disabled="true" :style="{ backgroundColor: '#F5F7FA'}"></money><span style="color: red">Cr</span>
                    </div>
                  </el-form-item>

                </el-col>
                <el-col :span="8" :offset="0">
                  <el-form-item>
                    <span>Default Settings</span>
                    <span style="margin-left: 95px;">Override for this transaction</span>
                  </el-form-item>

                  <el-form-item label-width="130px" prop="isWHTax" label="Apply WHTax">
                    <el-checkbox v-model="form.isWHTax" disabled></el-checkbox>
                    <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isWHTax }">{{ form.isWHTax ? 'Yes' : 'No' }}</span>
                    <el-switch :disabled="!form.isWHTax" v-model="form.isWHTaxSwitch" @change="() => calculateResults()" style="margin-left: 20px;"></el-switch>
                  </el-form-item>

                  <!-- <el-row :gutter="20">
                    <el-col :span="12" style="display: flex; justify-content: flex-end;">
                      <el-form-item label-width="100px" prop="isWHTax" label="Apply WHTax">
                        <el-checkbox v-model="form.isWHTax" disabled></el-checkbox>
                        <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isWHTax }">{{ form.isWHTax ? 'Yes' : 'No' }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="isWHTaxSwitch" size="mini">
                        <el-switch :disabled="!form.isWHTax" v-model="form.isWHTaxSwitch" @change="() => calculateResults()"></el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row> -->

                  <el-form-item label-width="130px" prop="isVatWHTax" label="Apply VAT WHTax">
                    <el-checkbox v-model="form.isVatWHTax" disabled></el-checkbox>
                    <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isVatWHTax }">{{ form.isVatWHTax ? 'Yes' : 'No' }}</span>
                    <el-switch :disabled="!form.isVatWHTax" v-model="form.isVatWHTaxSwitch" @change="() => calculateResults()" style="margin-left: 20px;"></el-switch>
                  </el-form-item>

                  <!-- <el-row :gutter="20">
                    <el-col :span="12" style="display: flex; justify-content: flex-end;">
                      <el-form-item label-width="130px" prop="isVatWHTax" label="Apply VAT WHTax">
                        <el-checkbox v-model="form.isVatWHTax" disabled></el-checkbox>
                        <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isVatWHTax }">{{ form.isVatWHTax ? 'Yes' : 'No' }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="isVatWHTaxSwitch" size="mini">
                        <el-switch :disabled="!form.isVatWHTax" v-model="form.isVatWHTaxSwitch" @change="() => calculateResults()"></el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row> -->

                  <el-form-item label-width="130px" prop="serviceVATCode" label="Service VAT Code">
                    <el-input v-model="form.serviceVATCode" readonly placeholder="Service VAT Code">
                    </el-input>
                  </el-form-item>

                  <el-form-item label-width="130px" prop="productVATCode" label="Product VAT Code">
                    <el-input v-model="form.productVATCode" readonly placeholder="Product VAT Code">
                    </el-input>
                  </el-form-item>

                </el-col>
               </el-row>
              <!-- e -->

              <!-- <el-row :span="24" :gutter="20">
                <el-col :span="5">
                  <el-form-item label-width="134px" prop="clientTin" label="Client TIN">
                    <el-input v-model="form.clientTin" readonly placeholder="Client TIN" style='width: 100%;'>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" class="el-form-item__label">
                  Default Settings
                </el-col>
                <el-col :span="4" class="el-form-item__label">
                  Override for this transaction
                </el-col>
              </el-row> -->

              <!-- <el-row :gutter="20">
                <el-col :span="5" :offset="0">
                  <el-form-item label-width="134px" prop="typeOfBusiness" label="Type of Business">
                    <el-input v-model="form.typeOfBusiness" readonly placeholder="Type of Business">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3" style="display: flex; justify-content: flex-end;">
                  <el-form-item label-width="100px" prop="isWHTax" label="Apply WHTax">
                    <el-checkbox v-model="form.isWHTax" disabled></el-checkbox>
                    <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isWHTax }">{{ form.isWHTax ? 'Yes' : 'No' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="isWHTaxSwitch" size="mini">
                    <el-switch :disabled="!form.isWHTax" v-model="form.isWHTaxSwitch" @change="() => calculateResults()"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row> -->

              <!-- <el-row :gutter="20">
                <el-col :span="5" :offset="0">
                  <el-form-item label-width="134px" prop="paymentTerms" label="Payment Terms">
                    <el-input v-model="form.paymentTerms" readonly placeholder="Payment Terms">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3" style="display: flex; justify-content: flex-end;">
                  <el-form-item label-width="130px" prop="isVatWHTax" label="Apply VAT WHTax">
                    <el-checkbox v-model="form.isVatWHTax" disabled></el-checkbox>
                    <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isVatWHTax }">{{ form.isVatWHTax ? 'Yes' : 'No' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="isVatWHTaxSwitch" size="mini">
                    <el-switch :disabled="!form.isVatWHTax" v-model="form.isVatWHTaxSwitch" @change="() => calculateResults()"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row> -->

              <!-- <el-row :span="24" :gutter="20">
                <el-col :span="5">
                  <el-form-item
                      label-width="134px"
                      prop="currency"
                      label="Currency">
                      <span
                          v-if="form.currency"
                      >
                        {{form.currency }}
                      </span>
                  </el-form-item>
                </el-col>
                <el-col :span="5" :offset="0">
                  <el-form-item label-width="130px" prop="serviceVATCode" label="Service VAT Code">
                    <el-input v-model="form.serviceVATCode" readonly placeholder="Service VAT Code">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->

              <!-- <el-row :span="24" :gutter="20">
                <el-col :span="5">
                  <el-form-item
                      label-width="174px"
                      prop="clResult"
                      label="Under/Over Pmt Balance">
                    <div style="display: flex; align-items: center; gap: 4px;" >
                      <money v-model="form.clResult" v-bind="money" :disabled="true" :style="{ backgroundColor: '#F5F7FA'}"></money><span style="color: red">Cr</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="5" :offset="0">
                  <el-form-item label-width="130px" prop="productVATCode" label="Product VAT Code">
                    <el-input v-model="form.productVATCode" readonly placeholder="Product VAT Code">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->

              <div style="max-width: 300px; position: absolute; top: 20px; right: 20px;">
                <el-row :span="24" :gutter="20">
                  <el-form-item label-width="150px" label="Transaction ID#">
                    <span class="transaction-no" @click="openJournalModal">
                      {{transactionNo}}
                    </span>
                  </el-form-item>
                  <el-form-item
                      label-width="150px"
                      prop="tranDate"
                      label="Transaction Date *">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="form.tranDate"
                        :clearable='false'
                        format="d MMM yy"
                        value-format="MM-dd-yyyy"
                        type="date"
                        placeholder="Select Date"
                        @change="handleDateChange">
                    </el-date-picker>
                  </el-form-item>
                </el-row>
              </div>
            </el-card>
            <el-card v-if="form.clientId" class="card card-2">
              <el-row :span="24" :gutter="20">
                <el-col :span="6">
                  <h4 style="margin-top: 0;">Type of Sale</h4>
                  <el-form-item prop="typeOfSale">
                    <el-radio-group :value="form.typeOfSale" class="radio-group-col">
                      <el-radio label="isSDtoSRA" @change="typeOfSaleChangeConfirm('isSDtoSRA')">Sales Direct to Service Revenue Account</el-radio>
                      <el-radio label="isSSI" @change="typeOfSaleChangeConfirm('isSSI')">Sales of Service Items</el-radio>
                      <el-radio label="isBoth" @change="typeOfSaleChangeConfirm('isBoth')">Both</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <h4 style="margin-top: 0;">Selling Currency</h4>
                  <span v-if="form.currency">
                    {{form.currency }}
                  </span>
                </el-col>
                <el-col :span="5">
                  <h4 style="margin-top: 0;">Sales Tax</h4>
                  <el-form-item label-width="130px" prop="amountsAre" label="Amounts Are">
                    <el-select
                        no-data-text="no date"
                        class="select"
                        v-model="form.amountsAre"
                        @change="changeAmountsAre"
                    >
                      <el-option
                          v-for="item in taxList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" :style="{'display': 'flex', 'align-items': 'flex-start'}">
                  <h4 style="margin-top: 0; min-width: 120px">Selling Notes *</h4>
                  <el-form-item prop="sellingNotes" style="display: flex">
                    <el-input class="t-textarea" rows="4" cols="50" type="textarea" v-model="form.sellingNotes"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <div :style="{ 'margin-top': '20px' }">
                <!-- <div :style="{'font-size': '14px', fontWeight: 'bold'}">Sales {{ form.typeOfSale === 'isSSI' ? 'of Service Items' : 'Direct to Service Revenue Account' }}</div> -->
                <div :style="{ 'display': 'flex', 'gap': '10px', 'align-items': 'center' }">
                  <el-tooltip :content="`Sales ${ form.typeOfSale === 'isSSI' ? 'of Service Items' : 'Direct to Service Revenue Account' }`" placement="top">
                    <i class="el-icon-warning warning-icon"></i>
                  </el-tooltip>
                  <el-form-item
                      :style="{ 'display': 'flex', 'align-items': 'center', 'margin-bottom': 0 }"
                      prop="generalSwitch"
                      :label="`Sales ${ form.typeOfSale === 'isSSI' ? 'of Service Items' : 'Direct to Service Revenue Account' }`">
                    <el-switch
                        class="t-switch"
                        v-model="form.generalSwitch">
                    </el-switch>
                  </el-form-item>
                </div>

                <CRServiceRevenueTable
                    v-if="form.generalSwitch"
                    ref="crServiceRevenue"
                    serviceRevenueKey="serviceRevenue"
                    :form="form"
                    :typeOfSale="form.typeOfSale"
                    otherRevenue
                    :disabledForm="disabledForm"
                    :serviceRevenue="form.serviceRevenue"
                    :accountsRevenue="accountsRevenue"
                    :units="units"
                    :lumpsumDiscountRates="lumpsumDiscountRates"
                    :salesTaxList="form.amountsAre === 4 ? salesTaxListTaxExemptTable : salesTaxList"
                    @calculateResults="calculateResults"
                    @addNewItem="(e) => addNewItem('serviceRevenue', e)"
                    @removeItem="(e) => removeItem('serviceRevenue', e)"
                />
<!--                <p>Total Amount: {{formatPrice(results.totalAmountFromTable)}}<br></p>-->
<!--                <p>Total Tax Amount: {{formatPrice(results.totalTaxAmountFromTable)}}<br></p>-->
<!--                <p>Total Discount Amount: {{formatPrice(results.totalDiscountFromTable)}}<br></p>-->
<!--                <p>Vatable Amount: {{formatPrice(results.vatableAmount)}}<br></p>-->
<!--                <p>VAT Exempt Amount: {{formatPrice(results.vatExAmount)}}<br></p>-->
<!--                <p>wTaxRate: {{form.whTaxRate}}<br></p>-->
<!--                <p>vatWhtaxRate: {{form.vatWhtaxRate}}<br></p>-->
              </div>
              <div :style="{ 'margin-top': '20px' }">
                <div :style="{ 'display': 'flex', 'gap': '10px', 'align-items': 'center' }">
                  <el-tooltip content="Sales Direct to Other Revenue Account" placement="top">
                    <i class="el-icon-warning warning-icon"></i>
                  </el-tooltip>
                  <el-form-item
                      :style="{ 'display': 'flex', 'align-items': 'center', 'margin-bottom': 0 }"
                      prop="salesDirectToMiscellaneous"
                      label="Sales Direct to Other Revenue Account">
                    <el-switch
                        class="t-switch"
                        v-model="form.salesDirectToMiscellaneous">
                    </el-switch>
                  </el-form-item>
                </div>

                <CRServiceRevenueTable
                    v-if="form.salesDirectToMiscellaneous"
                    ref="crServiceRevenue2"
                    serviceRevenueKey="serviceRevenue2"
                    :form="form"
                    :typeOfSale="form.typeOfSale"
                    otherRevenue
                    :disabledForm="disabledForm"
                    :serviceRevenue="form.serviceRevenue2"
                    :accountsRevenue="accountOthernRevenue"
                    :units="units"
                    :lumpsumDiscountRates="lumpsumDiscountRates"
                    :salesTaxList="form.amountsAre === 4 ? salesTaxListTaxExemptTable : salesTaxList"
                    @calculateResults="calculateResults"
                    @addNewItem="(e) => addNewItem('serviceRevenue2', e)"
                    @removeItem="(e) => removeItem('serviceRevenue2', e)"
                />
              </div>
              <div :style="{ 'margin-top': '20px' }">
                <div :style="{ 'display': 'flex', 'gap': '10px', 'align-items': 'center' }">
                  <el-tooltip content="Sales Direct to Non Revenue Account" placement="top">
                    <i class="el-icon-warning warning-icon"></i>
                  </el-tooltip>
                  <el-form-item
                      :style="{ 'display': 'flex', 'align-items': 'center', 'max-width': '500px', 'margin-bottom': 0 }"
                      prop="salesDirectToNonRevenueAccount"
                      label="Sales Direct to Non Revenue Account">
                    <el-switch
                        class="t-switch"
                        v-model="form.salesDirectToNonRevenueAccount">
                    </el-switch>
                  </el-form-item>
                </div>
                <CRServiceRevenueTable
                    v-if="form.salesDirectToNonRevenueAccount"
                    ref="salesDirectToNonRevenues"
                    serviceRevenueKey="salesDirectToNonRevenues"
                    :form="form"
                    :typeOfSale="form.typeOfSale"
                    otherRevenue
                    :disabledForm="disabledForm"
                    :serviceRevenue="form.salesDirectToNonRevenues"
                    :accountsRevenue="accountsNonRevenue"
                    :units="units"
                    :lumpsumDiscountRates="lumpsumDiscountRates"
                    :salesTaxList="form.amountsAre === 4 ? salesTaxListTaxExemptTable : salesTaxList"
                    @calculateResults="calculateResults"
                    @addNewItem="(e) => addNewItem('salesDirectToNonRevenues', e)"
                    @removeItem="(e) => removeItem('salesDirectToNonRevenues', e)"
                />
              </div>
              <div :style="{ 'margin-top': '20px', fontWeight: 'bold' }" v-if="form.typeOfSale === 'isBoth'">
                <div style="font-size: 14px;">Sales of Service Items</div>
                <CRServiceRevenueTable
                    ref="crSalesServiceItems"
                    serviceRevenueKey="salesServiceItems"
                    :form="form"
                    :typeOfSale="form.typeOfSale"
                    :disabledForm="disabledForm"
                    :serviceRevenue="form.salesServiceItems"
                    :accountsRevenue="accountsRevenueSales"
                    :units="units"
                    :lumpsumDiscountRates="lumpsumDiscountRates"
                    :salesTaxList="form.amountsAre === 4 ? salesTaxListTaxExemptTable : salesTaxList"
                    @calculateResults="calculateResults"
                    @addNewItem="(e) => addNewItem('salesServiceItems', e)"
                    @removeItem="(e) => removeItem('salesServiceItems', e)"
                />
              </div>
            </el-card>
            <div style="display:flex; gap: 20px;">
              <el-card class="card" style="width:100%;">
                <h4 style="margin-top: 0px;">Payment Details</h4>
                <el-row :span="24" :gutter="20">
                  <el-col :span="9">
                    <el-form-item
                        label-width="174px"
                        prop="clResult"
                        label="Under/Over Pmt Balance">
                      <div style="display: flex; align-items: center; gap: 4px;">
                        <money v-model="form.clResult" v-bind="money" :disabled="true" :style="{ backgroundColor: '#F5F7FA'}"></money><span style="color: red">Cr</span>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-button :disabled="!this.form.clientId" type="primary" size="mini" @click="useBalance">Use Balance</el-button>
                    <!-- <el-form-item prop="isUseBalance" size="mini" label="Use Balance" style="display: flex; align-items: center; justify-content: center;">
                      <el-switch
                          :disabled="form.clResult < 0"
                          v-model="form.isUseBalance"
                          @change="() => {
                            if (!form.isUseBalance) {
                              form.appliedUnderOverPMTBal = 0
                            }
                            calculateResults()
                          }"></el-switch>
                    </el-form-item> -->
                  </el-col>
                  <el-col :span="9">
                    <el-form-item
                        label-width="150px"
                        prop="appliedUnderOverPMTBal"
                        label="Over Pmt Applied">
                      <!-- <money
                          v-model="form.appliedUnderOverPMTBal"
                          v-bind="money"
                          :disabled="!form.isUseBalance"
                          :style="{ backgroundColor: !form.isUseBalance ? '#F5F7FA' : 'transparent' }"
                          @input.native="appliedUnderOverPMTChange"></money> -->
                        <money
                          v-model="form.appliedUnderOverPMTBal"
                          v-bind="money"
                          :disabled="true"
                          :style="{ backgroundColor: true ? '#F5F7FA' : 'transparent' }"></money>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div style="display: flex; flex-direction: row; gap: 20px;">
                  <div>
                    <el-form-item
                        label-width="140px"
                        label="Received Date *"
                        prop="receivedDate">
                      <el-date-picker
                          style="width: 100%"
                          v-model="form.receivedDate"
                          :clearable='false'
                          format="d MMM yy"
                          value-format="MM-dd-yyyy"
                          type="date"
                          placeholder="Select Date">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item
                        class="label-without-start"
                        label-width="140px"
                        v-if="form.currency && form.currency !== companyLayout.currency.code"
                        prop="exchangeRate"
                        label="Rate">
                      <el-input v-model="form.exchangeRate" type="number" placeholder="Rate" @input="() => calculateResults()"></el-input>
                    </el-form-item>
                    <el-form-item
                        label-width="140px"
                        prop="paymentCurrency"
                        label="Payment Currency *"
                        class="label-without-start">
                      <el-select
                          no-data-text="no date"
                          class="select"
                          v-model="form.paymentCurrency"
                          @change="() => calculateResults()"
                      >
                        <el-option
                            v-for="item in paymentCurrencyList"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                        label-width="140px"
                        label="Received By *"
                        prop="receivedBy"
                        class="label-without-start">
                      <el-select
                          no-data-text="no date"
                          placeholder="Received By"
                          class="select"
                          v-model="form.receivedBy"
                      >
                        <el-option
                            v-for="item in receivedByListChanged"
                            :key="item.id"
                            :label="item.fullName"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                        class="label-without-start"
                        label-width="140px"
                        prop="forUser"
                        label="For User *">
                      <el-select
                          no-data-text="no date"
                          placeholder="For User"
                          class="select"
                          v-model="form.forUser"
                      >
                        <el-option
                            v-for="item in forUserList"
                            :key="item.id"
                            :label="item.fullName"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label-width="140px" prop="actionsToDo" label="Mode of Payment">
                      <el-select
                          no-data-text="no date"
                          class="select"
                          v-model="form.modeOfPayment"
                          @change="calculateResults"
                      >
                        <el-option
                            v-for="item in modeOfPaymentList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div v-if="form.modeOfPayment === 1" style="flex: 1;">
                    <SinglePaymentMethod
                        ref="singlePM"
                        :disabledForm="disabledForm"
                        :paymentMethodList="paymentMethodList"
                        :receivedByList="forUserList"
                        @calculateResults="calculateResults"
                    />
                  </div>
                  <SplitsPaymentsMethod
                      v-if="form.modeOfPayment === 2"
                      ref="splitPM"
                      :disabledForm="disabledForm"
                      :paymentMethodList="paymentMethodList"
                      :receivedByList="forUserList"
                      @calculateResults="calculateResults"
                  />
                </div>

                <ClearingAccountMethod
                    ref="clearingAccount"
                    v-if="form.modeOfPayment === 3"
                />
                <ReceivePostDatedChequesMethod
                    ref="receivePostData"
                    v-if="form.modeOfPayment === 4"
                />
                <el-form-item
                    label-position="top"
                    label="Payment For *"
                    prop="paymentFor"
                    class="label-without-start">
                  <el-input class="t-textarea" rows="4" cols="50" type="textarea" v-model="form.paymentFor"></el-input>
                </el-form-item>
              </el-card>
              <el-card class="card" style="min-width: 710px;">
                <h4 style="margin-top: 0px;">Transaction Summary</h4>
                <cash-receipt-result-no-tax
                    v-if="form.amountsAre === 1"
                    :appliedUnderOverPMTBal="form.appliedUnderOverPMTBal"
                    :otherRevenueCharges="results.otherRevenueCharges"
                    :nonRevenueCharges="results.nonRevenueCharges"
                    :discount="results.discount"
                    :vatableAmount="results.vatableAmount"
                    :vatExAmount="results.vatExAmount"
                    :zeroRatedAmount="results.zeroRatedAmount"
                    :vatAmount="results.vatAmount"
                    :totalAmount="results.totalAmount"
                    :currency="form.currency"
                    :amountOwingClientCurrency="results.amountOwingClientCurrency"
                    :receivedAmountClientCurrency="results.receivedAmountClientCurrency"
                    :balanceOwingClientCurrency="results.balanceOwingClientCurrency"
                    :amountVatExcluded="results.amountVatExcluded"
                    :lessWHTax="results.lessWHTax"
                    :amountOwing="results.amountOwing"
                    :receivedAmount="results.receivedAmount"
                    :balanceOwing="results.balanceOwing"
                    :overPayment="results.overPayment"
                    :underPayment="results.underPayment"
                    :addVatAmount="results.addVatAmount"
                    :totalAmountVatInclusinve="results.totalAmountVatInclusinve"
                    :totalAmountNoTax="results.totalAmountNoTax"
                    :lessCreditableWithholdingTax="results.lessCreditableWithholdingTax"
                    :underPaymentClientCurrency="results.underPaymentClientCurrency"
                    :overPaymentClientCurrency="results.overPaymentClientCurrency"
                    :transaction="transaction"
                    :transactionNo="transactionNo"
                />
                <cash-receipt-result-tax-exempt
                    v-else
                    :appliedUnderOverPMTBal="form.appliedUnderOverPMTBal"
                    :otherRevenueCharges="results.otherRevenueCharges"
                    :nonRevenueCharges="results.nonRevenueCharges"
                    :discount="results.discount"
                    :vatableAmount="results.vatableAmount"
                    :vatExAmount="results.vatExAmount"
                    :zeroRatedAmount="results.zeroRatedAmount"
                    :vatAmount="results.vatAmount"
                    :totalAmount="results.totalAmount"
                    :currency="form.currency"
                    :amountOwingClientCurrency="results.amountOwingClientCurrency"
                    :receivedAmountClientCurrency="results.receivedAmountClientCurrency"
                    :balanceOwingClientCurrency="results.balanceOwingClientCurrency"
                    :amountVatExcluded="results.amountVatExcluded"
                    :lessWHTax="results.lessWHTax"
                    :amountOwing="results.amountOwing"
                    :receivedAmount="results.receivedAmount"
                    :balanceOwing="results.balanceOwing"
                    :overPayment="results.overPayment"
                    :underPayment="results.underPayment"
                    :addVatAmount="results.addVatAmount"
                    :totalAmountVatInclusinve="results.totalAmountVatInclusinve"
                    :totalAmountNoTax="results.totalAmountNoTax"
                    :lessCreditableWithholdingVat="results.lessCreditableWithholdingVat"
                    :lessCreditableWithholdingTax="results.lessCreditableWithholdingTax"
                    :underPaymentClientCurrency="results.underPaymentClientCurrency"
                    :overPaymentClientCurrency="results.overPaymentClientCurrency"
                    :depositToken="0"
                    :transaction="transaction"
                    :transactionNo="transactionNo"
                />
              </el-card>
            </div>
          </el-form>
          <div class="actions" :span="24" :gutter="20" style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 20px;">
              <div>
                <div style="margin-bottom: 10px;">
                  Created By:
                  <span v-if="!$route.params.id && user && user.user"> <b>{{user.user.firstname}} {{user.user.lastname}}</b></span>
                  <span v-else> <b>{{form.createByFullName}}</b></span>
                </div>
                <div class="actions__wrapper">
                  <el-button v-if="companyLayout.permission.historyAccountThinkCashReceipt" :disabled="!$route.params.id" type="primary" size="mini" @click="openModalHistory">History</el-button>
                  <el-button v-if="(!isBlock || (isBlock && companyLayout.permission.makeTransactionAdjustmentsInLockedPeriod)) && companyLayout.permission.reverseAccountThinkCashReceipt" :disabled="status != 'Post'" size="mini" @click="reverse($route.params.id)">Reverse</el-button>
                </div>
              </div>
              <div v-if="!isBlock || (isBlock && companyLayout.permission.makeTransactionAdjustmentsInLockedPeriod)">
                <div class="actions__wrapper">
                  <el-button v-if="companyLayout.permission.addAccountThinkCashReceipt" :disabled="!!$route.params.id" type="primary" size="mini" @click="add(false)">Add</el-button>
                  <el-button v-if="companyLayout.permission.addAccountThinkCashReceipt" :disabled="!!$route.params.id" type="primary" size="mini" @click="addAndNew(false)">Add and New</el-button>
                  <el-button v-if="(disabledForm && !updatedState) && companyLayout.permission.editAccountThinkCashReceipt" :disabled="isDisabledEdit" size="mini" @click="() => {
                    updatedState = true
                    disabledForm = false
                  }">Edit</el-button>
                  <el-button v-else-if="updatedState" size="mini" @click="add($route.params.id)" :disabled="isDisabledEdit">Save Changes</el-button>
                  <el-button v-if="companyLayout.permission.checkedAccountThinkCashReceipt" :disabled="status != 'Add'" size="mini" @click="checked($route.params.id)">Checked</el-button>
                  <el-button v-if="companyLayout.permission.sendToAccountantAccountThinkCashReceipt" :disabled="status != 'Check'" size="mini" @click="sendToAccountant($route.params.id)">Send to Accountant</el-button>
                  <el-button v-if="(status === 'Post') && companyLayout.permission.voidAccountThinkCashReceipt" :disabled="status === 'Void' || status === 'Reverse'" size="mini" @click="voidCashReceipt($route.params.id)">Void</el-button>
                  <el-button v-if="(status !== 'Post') && companyLayout.permission.deleteAccountThinkCashReceipt" :disabled="status === 'Void' || status === 'Reverse' || !status" size="mini" @click="deleteCashReceipt($route.params.id)">Delete</el-button>
                  <el-dropdown v-if="companyLayout.permission.recordAccountThinkCashReceipt" placement="top-start" style="margin-left: 10px" size="mini" split-button type="primary">
                    Record and
                    <el-dropdown-menu  slot="dropdown">
                      <el-dropdown-item :disabled="status != 'Check'" @click.native="issueOfficialReceiptOpenModal">Issue VAT Sales Invoice</el-dropdown-item>
                      <el-dropdown-item :disabled="!!$route.params.id" >Issue Acknowledge Receipt</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <el-button :disabled="!transactionNo" type="primary" size="mini" style="margin-left: 10px;" @click="openJournalModal">View Transaction</el-button> -->
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <IssueOfficialReceiptModal :transactionNo="transactionNo" :cashReceiptHeaderId="$route.params.id" :paymentFor="form.paymentFor" :transactionId="form.transactionId" ref="issueOfficialReceiptModal" @loadList="init"/>
    <modal-history :historyList='historyList' ref="openHistory"></modal-history>
    <cash-receipt-journal-modal ref="cashReceiptModal" @setReceiveFor="setReceiveFor"/>
    <add-client-form-modal ref="modal11" :directories="clientVendorDirectories" @selected="selectClient"/>
    <editJournalEntryModal :showInfo="false" ref="editJournalEntryModal"/>
    <CRUseBalance
      :amountOwing="results.amountOwing"
      :totalAmountVatInclusinve="results.totalAmountVatInclusinve"
      :tableData="listCRForUseBalance"
      @overPMTBal="initAppliedUnderOverPMTBal"
      ref="CRUseBalance"/>
  </div>
</template>

<script>
import axios from 'axios'
import { Money } from 'v-money'
import SplitsPaymentsMethod from "@/components/cashReceipts/SplitsPaymentsMethod.vue";
import SinglePaymentMethod from "@/components/cashReceipts/SinglePaymentMethod.vue";
import ClearingAccountMethod from "@/components/cashReceipts/ClearingAccountMethod.vue";
import ReceivePostDatedChequesMethod from "@/components/cashReceipts/ReceivePostDatedChequesMethod.vue";
import CashReceiptResultNoTax from "@/components/cashReceipts/results/CashReceiptResultNoTax.vue";
import CashReceiptResultTaxExempt from "@/components/cashReceipts/results/CashReceiptResultTaxExempt.vue";
import CRServiceRevenueTable from "@/components/cashReceipts/tables/CRServiceRevenueTable.vue";
import CRUseBalance from "@/components/cashReceipts/tables/CRUseBalance.vue";
import IssueOfficialReceiptModal from "@/components/cashReceipts/IssueOfficialReceiptModal.vue";
import moment from "moment";
import ModalHistory from "@/components/journalAndGl/historyJournalEntry.vue";
import CashReceiptJournalModal from '@/layout/components/yourOrganization/CashReceiptJournalModal.vue'
import AddClientFormModal from '@/components/clients/AddClientForm.vue'
const FASTFOREX_API_KEY = process.env.VUE_APP_FASTFOREX_API_KEY
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'

const itm = {
  no: null,
  revenueAccount: null,
  description: null,
  price: 0,
  unit: null,
  qty: 1,
  scpwdDiscountRate: null,
  discountAmount: null,
  totalAmount: 0,
  taxCode: null,
  taxRate: 0,
  isClientWHTax: false,
  isScPwd: false,
  entityTypeId: null,
  warehouseId: null,
  buId: null,
  parentId: null,
  taskId: null,
  userId: null,
  // lists
  whList: [],
  buList: [],
  parentList: [],
  taskList: [],
  userList: [],
  itemId: null,
  entityTypeList: [
    { id: 2, name: 'Business Unit' },
    { id: 4, name: 'Warehouse' },
    { id: 3, name: 'Engagement' },
    { id: 1, name: 'Project' },
  ],
  inventoryAssetAccountId: null,
  purchaseAccountId: null,
  costPrice: null,
  sellAccountId: null,
  discountAccountId: null,
}

export default {
  name: 'CashReceipts',
  components: {
    AddClientFormModal,
    CashReceiptJournalModal,
    ModalHistory,
    CRServiceRevenueTable,
    CashReceiptResultTaxExempt,
    CashReceiptResultNoTax,
    SinglePaymentMethod,
    SplitsPaymentsMethod,
    ClearingAccountMethod,
    ReceivePostDatedChequesMethod,
    IssueOfficialReceiptModal,
    editJournalEntryModal,
    Money,
    CRUseBalance,
  },
  data: vm => vm.initialData(),
  computed: {
    user() {
      return this.$store.state.user
    },
    companyLayout() {
      return this.$store.state.companyLayout
    },
    isAccountant() {
      return this.companyLayout.userRights.isAccountant
    },
    // addedByList() {
    //   return this.user.user ? [this.user.user] : []
    // },
    addedBy() {
      return this.user.user ? this.user.user.id : null
    },
    receivedByListChanged() {
      return this.forUserList.filter(val => val.isChequeReceipts)
    },
    selectedClient() {
      if (this.form.clientId) {
        const client = this.clientList.find(client => client.id === this.form.clientId)
        return client ? client : null
      }
      return null
    },
    // clientContactList() {
    //   if (this.selectedClient) {
    //     return this.selectedClient.persons
    //   }
    //   return []
    // },
    salesTaxListExemptTax() {
      return this.salesTaxList.find(tax => tax.exemptTax)
    },
    salesTaxListNoTaxSP() {
      return this.salesTaxList.find(tax => tax.noTaxSP)
    },
    salesTaxListNoTax() {
      return this.salesTaxList.find(tax => tax.noTax)
    },
    salesTaxListWithZeroRate() {
      return this.salesTaxList.find(tax => tax.zeroTax)
    },
    salesTaxListTaxExemptTable() {
      return [this.salesTaxListWithZeroRate, this.salesTaxListExemptTax]
    },
    paymentCurrencyList() {
      const currencies = []
      if (this.companyLayout && this.companyLayout.currency) {
        currencies.push(this.companyLayout.currency.code)
      }
      if (this.form.currency) {
        currencies.push(this.form.currency)
      }
      return [...new Set(currencies)]
    },
    isDisabledEdit() {
      if (this.status === 'Post' || this.status === 'Void') {
        return true
      }
      if (this.isSendToAcc && this.isAccountant) {
        return false
      }
      if (!this.isSendToAcc) {
        return false
      }
      return true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    handleDateChange(value) {
      // if (!this.companyLayout.lockAccountingPeriodTo) {
      //   this.$message.error("Set Lock Accounting Period")
      //   this.form.tranDate = null
      //   return
      // }

      if (this.companyLayout.lockAccountingPeriodTo) {
        const baseDate = new Date(this.companyLayout.lockAccountingPeriodTo)
        baseDate.setHours(0, 0, 0, 0)

        const [month, day, year] = value.split('-').map(Number)
        const selectedDate = new Date(year, month - 1, day)

        if (selectedDate.getTime() <= baseDate.getTime()) {
          this.$message.error("This is a locked period; you cannot create, edit, or modify transactions during this period.")
          this.form.tranDate = null
        }
        // this.companyLayout.lockAccountingPeriodTo
        // this.form.tranDate = null
      }
    },
    async useBalance() {
      if (!this.listCRForUseBalance.length) await this.getListCRForUseBalance()
      this.$refs.CRUseBalance.open()
    },
    async createCashReceiptUseBalance(cashReceiptHeader) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/cashReceiptOverPayment/create?companyId=${this.$route.query.companyId}`, {
          cashReceiptHeaderIdIn: cashReceiptHeader.id,
          cashReceiptPaymentsList: this.listCRForUseBalance
        })
      } catch (error) {
        console.log(error)
      } finally {
        loader.hide()
      }
    },
    initAppliedUnderOverPMTBal(value) {
      this.form.appliedUnderOverPMTBal = value
      this.calculateResults()
    },
    async getListCRForUseBalance() {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/cashReceipt/byClientOverPayment?clientId=${this.form.clientId}&startDate=null&endDate=null`)
        // const arr = []
        // data.result.table.forEach((item) => {
        //   item.date = item.date ? moment(item.date).format("D MMM YYYY") : ''
        //   item.cashReceiptHeaderIdOut = item.id
        //   item.amtApplied = 0

        //   const { date, crid, owing, overpmtcr, amtApplied,  cashReceiptHeaderIdOut } = item;
        //   const newObj = { date, crid, owing, overpmtcr, amtApplied,  cashReceiptHeaderIdOut };
        //   arr.push(newObj)
        // })
        // this.listCRForUseBalance = arr

        this.listCRForUseBalance = data.result.table.map(({ date, crid, owing, overpmtcr, amtApplied = 0, id:cashReceiptHeaderIdOut }) => ({ date, crid, owing, overpmtcr, amtApplied,  cashReceiptHeaderIdOut }))
      } catch (error) {
        console.log(error)
      } finally {
        loader.hide()
      }
    },
    async init() {
      let loader = this.$loading.show();
      try {
        await this.directories()
        const response = await axios.get(`/api/v1/items/active-list?companyId=${this.$route.query.companyId}`)
        this.accountsRevenueSales = response.data.list.filter(val => val.sell)
        await this.getAccountOnlyTax()
        await this.checkTaxes()
        if (this.$route.params.id) {
          this.disabledForm = true
          const item = await this.item(this.$route.params.id)
          if (item.isSSI) {
            await this.typeOfSaleChange('isSSI')
          }
          await this.itemImg(item.saveTranId)
        }
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async getWarehouses() {
      try {
        const { data } = await axios.post(`/api/v1/inventories/list?companyId=${this.$route.query.companyId}`)
        return  data.inventoryList
      } catch (err) {
        console.log(err)
      }
    },
    async item(id) {
      try {
        const whList = await this.getWarehouses()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/cashReceipt/item?id=${id}`)
        console.log('data.item ====', data.item.appliedUnderOverPMTBal)
        this.isBlock = data.item.isBlock
        this.status = data.item.status
        this.form.clientId = data.item.clientId
        await this.setClient(data.item.clientId)
        await this.getClientUnderOverPayment(data.item.clientId)
        this.form.appliedUnderOverPMTBal = data.item.appliedUnderOverPMTBal
        this.form.isWHTaxSwitch = data.item.isWHTaxToggle
        this.form.isVatWHTaxSwitch = data.item.isVatWHTaxToggle
        this.form.isUseBalance = data.item.isUseBalanceToggle
        this.form.clientTin = data.item.clientTin

        this.form.typeOfBusiness = data.item.typeOfBusiness
        this.form.paymentTerms = data.item.paymentTerms
        this.form.serviceVATCode = data.item.serviceVATCode
        this.form.productVATCode = data.item.productVATCode

        // const arr = []
        // data.item.cashReceiptOverPayments.forEach((item) => {
        //   item.date = item.date ? moment(item.date).format("D MMM YYYY") : ''

        //   const { date, crid, owing, overpmtcr, amtApplied,  cashReceiptHeaderIdOut } = item;
        //   const newObj = { date, crid, owing, overpmtcr, amtApplied,  cashReceiptHeaderIdOut };
        //   arr.push(newObj)
        // })
        // this.listCRForUseBalance = arr

        this.listCRForUseBalance = data.item.cashReceiptOverPayments.map(({ date, crid, owing, overpmtcr, amtApplied,  cashReceiptHeaderIdOut }) => ({ date, crid, owing, overpmtcr, amtApplied,  cashReceiptHeaderIdOut }))

        this.form.paymentCurrency = data.item.paymentCurrency
        this.form.exchangeRate = data.item.fxRate
        this.form.transactionId = data.item.tranId
        this.form.paymentFor = data.item.paymentFor
        this.transaction = data.item.transaction ? data.item.transaction : {}
        this.isSendToAcc = data.item.transaction ? data.item.transaction.isSendToAcc : false
        this.form.createByFullName = data.item.createByFullName
        this.transactionNo = data.item.transaction.transactionNo
        this.form.tranDate = moment(data.item.crDate).format("MM-DD-YYYY")
        if (data.item.isSDtoSRA) {
          this.form.typeOfSale = 'isSDtoSRA'
        }else if (data.item.isSSI) {
          this.form.typeOfSale = 'isSSI'
        } else if (data.item.isBoth) {
          this.form.typeOfSale = 'isBoth'
          this.form.salesServiceItems = data.item.cashReceiptDetails.filter(val => val.typeTable === 'salesServiceItems').map(val => ({
            ...val,
            discountAccountId: val.discountAccountId,
            no: val.accountNumber,
            revenueAccount: val.accountId,
            description: val.details,
            price: val.unitPrice,
            unit: val.unitId,
            qty: val.qty,
            totalAmount: val.totalAmount,
            isClientWHTax: val.isClientWHTax,
            taxCode: val.taxCodeId,
            taxRate: val.taxRate,
            entityTypeId: val.allocatedTo,
            parentId: val.whsengproId,
            userId: val.euId,
            buList: val.bu ? [val.bu] : [],
            parentList: val.entity ? [val.entity] : [],
            taskList: val.task ? [val.task] : [],
            userList: val.user ? [{ userId: val.user.id, userFullName: val.user.name }] : [],
            whList: whList,
            inventoryAssetAccountId: val.inventoryAssetAccountId,
            purchaseAccountId: val.purchaseAccountId,
            costPrice: val.costPrice,
            entityTypeList: [
              { id: 2, name: 'Business Unit' },
              { id: 4, name: 'Warehouse' },
              { id: 3, name: 'Engagement' },
              { id: 1, name: 'Project' },
            ]
          }))
        }
        this.form.sellingNotes = data.item.sellingNotes
        this.form.amountsAre = data.item.amountsAre
        if (data.item.cashReceiptDetails.filter(val => !val.isOtherRevenue && val.typeTable === 'serviceRevenue').length) {
          this.form.serviceRevenue = data.item.cashReceiptDetails.filter(val => !val.isOtherRevenue && val.typeTable === 'serviceRevenue').map(val => ({
            ...val,
            discountAccountId: val.discountAccountId,
            no: val.accountNumber,
            revenueAccount: val.accountId,
            description: val.details,
            price: val.unitPrice,
            unit: val.unitId,
            qty: val.qty,
            totalAmount: val.totalAmount,
            isClientWHTax: val.isClientWHTax,
            taxCode: val.taxCodeId,
            taxRate: val.taxRate,
            entityTypeId: val.allocatedTo,
            parentId: val.whsengproId,
            userId: val.euId,
            buList: val.bu ? [val.bu] : [],
            parentList: val.entity ? [val.entity] : [],
            taskList: val.task ? [val.task] : [],
            userList: val.user ? [{ userId: val.user.id, userFullName: val.user.name }] : [],
            whList: whList,
            inventoryAssetAccountId: val.inventoryAssetAccountId,
            purchaseAccountId: val.purchaseAccountId,
            costPrice: val.costPrice,
            entityTypeList: [
              { id: 2, name: 'Business Unit' },
              { id: 4, name: 'Warehouse' },
              { id: 3, name: 'Engagement' },
              { id: 1, name: 'Project' },
            ]
          }))
        }

        if (data.item.cashReceiptDetails.filter(val => val.isOtherRevenue).length) {
          this.form.serviceRevenue2 = data.item.cashReceiptDetails.filter(val => val.isOtherRevenue).map(val => ({
            ...val,
            discountAccountId: val.discountAccountId,
            no: val.accountNumber,
            revenueAccount: val.accountId,
            description: val.details,
            price: val.unitPrice,
            unit: val.unitId,
            qty: val.qty,
            totalAmount: val.totalAmount,
            isClientWHTax: val.isClientWHTax,
            taxCode: val.taxCodeId,
            taxRate: val.taxRate,
            entityTypeId: val.allocatedTo,
            parentId: val.whsengproId,
            userId: val.euId,
            buList: val.bu ? [val.bu] : [],
            parentList: val.entity ? [val.entity] : [],
            taskList: val.task ? [val.task] : [],
            userList: val.user ? [{ userId: val.user.id, userFullName: val.user.name }] : [],
            whList: whList,
            inventoryAssetAccountId: val.inventoryAssetAccountId,
            purchaseAccountId: val.purchaseAccountId,
            costPrice: val.costPrice,
            entityTypeList: [
              { id: 2, name: 'Business Unit' },
              { id: 4, name: 'Warehouse' },
              { id: 3, name: 'Engagement' },
              { id: 1, name: 'Project' },
            ]
          }))
        }

        if (data.item.cashReceiptDetails.filter(val => val.isNonRevenue).length) {
          this.form.salesDirectToNonRevenues = data.item.cashReceiptDetails.filter(val => val.isNonRevenue).map(val => ({
            ...val,
            discountAccountId: val.discountAccountId,
            no: val.accountNumber,
            revenueAccount: val.accountId,
            description: val.details,
            price: val.unitPrice,
            unit: val.unitId,
            qty: val.qty,
            totalAmount: val.totalAmount,
            isClientWHTax: val.isClientWHTax,
            taxCode: val.taxCodeId,
            taxRate: val.taxRate,
            entityTypeId: val.allocatedTo,
            parentId: val.whsengproId,
            userId: val.euId,
            buList: val.bu ? [val.bu] : [],
            parentList: val.entity ? [val.entity] : [],
            taskList: val.task ? [val.task] : [],
            userList: val.user ? [{ userId: val.user.id, userFullName: val.user.name }] : [],
            whList: whList,
            inventoryAssetAccountId: val.inventoryAssetAccountId,
            purchaseAccountId: val.purchaseAccountId,
            costPrice: val.costPrice,
            entityTypeList: [
              { id: 2, name: 'Business Unit' },
              { id: 4, name: 'Warehouse' },
              { id: 3, name: 'Engagement' },
              { id: 1, name: 'Project' },
            ]
          }))
        }


        this.form.generalSwitch = !!data.item.cashReceiptDetails.filter(val => !val.isOtherRevenue && val.typeTable === 'serviceRevenue').length
        this.form.salesDirectToMiscellaneous = !!data.item.cashReceiptDetails.filter(val => val.isOtherRevenue).length
        this.form.salesDirectToNonRevenueAccount = !!data.item.cashReceiptDetails.filter(val => val.isNonRevenue).length
        if (data.item.isSinglePayment) {
          this.form.modeOfPayment = 1
        } else if (data.item.isSplitPayment) {
          this.form.modeOfPayment = 2
        } else if (data.item.isClearingAccount) {
          this.form.modeOfPayment = 3
        } else if (data.item.isPDC) {
          this.form.modeOfPayment = 4
        }
        if (this.form.modeOfPayment === 1) {
          // this.$refs.singlePM.form.receivedDate = moment(data.item.cashReceiptPayments[0].receivedDate).format("MM-DD-YYYY")
          this.form.receivedDate = moment(data.item.cashReceiptPayments[0].receivedDate).format("MM-DD-YYYY")
          this.$refs.singlePM.form.paymentMethodId = data.item.cashReceiptPayments[0].paymentMethodId
          // await this.$nextTick()
          this.$refs.singlePM.changePaymentMethod()
          this.$refs.singlePM.form.depositAccountId = data.item.cashReceiptPayments[0].depositAccountId
          this.$refs.singlePM.form.chequeRefNo = data.item.cashReceiptPayments[0].chequeRefNo
          this.$refs.singlePM.form.amountReceived = data.item.cashReceiptPayments[0].amountReceived
        }
        if (this.form.modeOfPayment === 2) {
          const items = data.item.cashReceiptPayments.map(val => {
            const pm = this.paymentMethodList.find(item => item.id === val.paymentMethodId)
            return {
              receivedDate: moment(val.receivedDate).format("MM-DD-YYYY"),
              paymentMethodId: val.paymentMethodId,
              depositAccountId: val.depositAccountId,
              chequeRefNo: val.chequeRefNo,
              amountReceived: val.amountReceived,
              depositAccountList: pm ? pm.accounts : [],
              balanceToReceived: val.balanceToReceived,
            }
          })
          await this.$nextTick()
          this.$refs.splitPM.form.items = items
          // await this.calculateBalanceToReceived()
        }
        this.form.receivedBy = data.item.receivedBy
        this.form.forUser = data.item.forUser
        return data.item
      } catch (err) {
        console.log(err)
      }
    },
    async changeClient(val) {
      this.getClientUnderOverPayment(val)
      const client = this.clientList.find(client => client.id === val)
      if (client.currency === this.companyLayout.currency.code) {
        this.form.paymentCurrency = this.companyLayout.currency.code
      }
      // this.form.clientContactId = null
      await this.getClientRate(client)
      this.form.clientEmail = client.email
      this.form.currency = client.currency
      this.form.clientTin = client.tin

      this.form.typeOfBusiness = client.typeOfBusiness
      this.form.paymentTerms = client.paymentTerms

      if (client.typeOfBusiness === 'Service') {
        this.form.serviceVATCode = client.saleTax ? client.saleTax.code : null
        this.form.productVATCode = null
      } else if (client.typeOfBusiness === 'Products') {
        this.form.serviceVATCode = null
        this.form.productVATCode = client.saleTax ? client.saleTax.code : null
      } else {
        this.form.serviceVATCode = client.saleTax ? client.saleTax.code : null
        this.form.productVATCode = client.saleTax ? client.saleTax.code : null
      }

      this.form.isVatWHTax = client.applyVatWHTax
      this.form.isVatWHTaxSwitch = false
      this.form.isWHTax = client.applyWHTax
      this.form.isWHTaxSwitch = false
      this.form.saleTaxId = client.saleTaxId
      this.form.applyVatWHTaxObj = client.applyVatWHTaxObj
      this.form.applyWHTaxObj = client.applyWHTaxObj
      this.form.whTaxRate = this.form.applyWHTaxObj ? +this.form.applyWHTaxObj.rate : 0
      this.form.vatWhtaxRate = this.form.applyVatWHTaxObj ? +this.form.applyVatWHTaxObj.rate : 0

      // clear Apply Over Payments
      this.listCRForUseBalance = []

      // clear
      this.form.isUseBalance = false
      this.form.appliedUnderOverPMTBal = 0
      this.setTaxCodeToTable()
      // this.$refs.cashReceiptModal.openModal()
    },
    getClientUnderOverPayment(id) {
      return new Promise(resolve => {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/cashReceipt/clientUnderOverPayment?clientId=${id}`).then(response => {
          const { data } = response
          this.form.clResult = data.result.clResult
          this.form.clResultAfterRate = data.result.clResultAfterRate
          loader.hide()
          resolve()
        }).catch(err => {
          console.log(err)
          loader.hide()
        })
      })
    },
    async setClient(val) {
      const client = this.clientList.find(client => client.id === val)
      this.form.clientEmail = client.email
      this.form.currency = client.currency
      this.form.isVatWHTax = client.applyVatWHTax
      this.form.isWHTax = client.applyWHTax
      this.form.saleTaxId = client.saleTaxId
      this.form.applyVatWHTaxObj = client.applyVatWHTaxObj
      this.form.applyWHTaxObj = client.applyWHTaxObj
      this.form.whTaxRate = this.form.applyWHTaxObj ? +this.form.applyWHTaxObj.rate : 0
      this.form.vatWhtaxRate = this.form.applyVatWHTaxObj ? +this.form.applyVatWHTaxObj.rate : 0
      // this.setTaxCodeToTable()
    },
    async getClientRate(client) {
      let loader = this.$loading.show();
      try {
        console.log(`[FastForex FetchOne Request] URL: https://api.fastforex.io/fetch-one?from=${client.currency}&to=${this.companyLayout.currency.code}&api_key=${FASTFOREX_API_KEY}`);
        const { data } = await new Promise((resolve) => {
          resolve({
            data: {
              result: {
                [this.companyLayout.currency.code]: 1
              }
            }
          })
        })
        this.form.exchangeRate = data.result[this.companyLayout.currency.code]
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    setTaxCodeToTable() {
      return new Promise((resolve) => {
        switch(this.form.amountsAre) {
          case 1:
            this.form.serviceRevenue = this.form.serviceRevenue.map((item) => ({...item, taxCode: this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null }))
            this.form.serviceRevenue2 = this.form.serviceRevenue2.map((item) => ({...item, taxCode: this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null }))
            this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null }))
            this.form.salesDirectToNonRevenues = this.form.salesDirectToNonRevenues.map((item) => ({...item, taxCode: this.salesTaxListNoTax ? this.salesTaxListNoTax.id : null }))
            break
          case 2:
          case 3:
            this.form.serviceRevenue = this.form.serviceRevenue.map((item) => ({...item, taxCode: this.form.saleTaxId }))
            this.form.serviceRevenue2 = this.form.serviceRevenue2.map((item) => ({...item, taxCode: this.form.saleTaxId }))
            this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: this.form.saleTaxId }))
            this.form.salesDirectToNonRevenues = this.form.salesDirectToNonRevenues.map((item) => ({...item, taxCode: this.form.saleTaxId }))
            break
          case 4:
            this.form.serviceRevenue = this.form.serviceRevenue.map((item) => ({...item, taxCode: this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null }))
            this.form.serviceRevenue2 = this.form.serviceRevenue2.map((item) => ({...item, taxCode: this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null }))
            this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null }))
            this.form.salesDirectToNonRevenues = this.form.salesDirectToNonRevenues.map((item) => ({...item, taxCode: this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null }))
            break
          default:
            this.form.serviceRevenue = this.form.serviceRevenue.map((item) => ({...item, taxCode: null }))
            this.form.serviceRevenue2 = this.form.serviceRevenue2.map((item) => ({...item, taxCode: null }))
            this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: null }))
            this.form.salesDirectToNonRevenues = this.form.salesDirectToNonRevenues.map((item) => ({...item, taxCode: null }))
        }
        resolve('ok')
      })
    },
    directories() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('getCompanyLayout').then(() => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/cashReceipt/directories?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}`)
              .then(response => {
                this.clientList = response.data.directories.client
                this.forUserList = response.data.directories.forUser
                this.accountsRevenue = response.data.directories.accountsRevenue
                this.accountsNonRevenue = response.data.directories.accountsNonRevenue
                this.accountOthernRevenue = response.data.directories.accountOthernRevenue
                this.units = response.data.directories.unit
                // this.salesTaxList = response.data.directories.salesTaxList
                this.paymentMethodList = response.data.directories.paymentMethodList
                resolve('ok')
              })
              .catch(error => {
                console.log(error)
                reject('error')
              });
        })
      })
    },
    getAccountOnlyTax() {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/account/accountOnlyTax?companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('response', response)
              this.salesTaxList = response.data.list ? response.data.list.output : []
              resolve('ok')
            })
            .catch(error => {
              reject('error')
            })
      })
    },
    calculateBalanceToReceived() {
      // console.log('this.results.amountOwing', this.results.amountOwing)
      const ifClientCurrency = this.form.paymentCurrency === this.form.currency
      console.log('ifCurrenciesEqual', ifClientCurrency ? this.results.amountOwing : this.results.amountOwingClientCurrency)
      this.$refs.splitPM.form.items.forEach((val, index) => {
        if (index === 0) {
          val.balanceToReceived = (ifClientCurrency ? this.results.amountOwing : this.results.amountOwingClientCurrency) - val.amountReceived
        } else {
          val.balanceToReceived = this.$refs.splitPM.form.items[index-1].balanceToReceived - val.amountReceived
        }
      })
    },
    checkTaxes() {
      if (!this.salesTaxListExemptTax || !this.salesTaxListNoTaxSP || !this.salesTaxListWithZeroRate) {
        this.$alert(`For our system to function correctly, it is necessary to establish the appropriate taxes. Please ensure that the Tax Libraries are configured with No tax, Zero rated, and Tax Exempt options.`, 'Warning', {
          confirmButtonText: 'OK',
          type: 'info',
          callback: action => {
            this.$router.push(`/settings-tax-libraries?companyId=${this.$route.query.companyId}`)
          }
        });
      }
    },
    addNewItem(table, index, row) {
      const newItem = {...itm, taxCode: this.form.saleTaxId, typeTable: table  }
      if (this.form.amountsAre === 4) {
        newItem.taxCode = this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null
      }
      this.form[table].push(newItem)
      return row
    },
    // addNewItem2(index, row) {
    //   const itm = {
    //     no: null,
    //     revenueAccount: null,
    //     description: null,
    //     price: 0,
    //     unit: null,
    //     qty: 1,
    //     scpwdDiscountRate: null,
    //     discountAmount: null,
    //     totalAmount: 0,
    //     taxCode: this.form.saleTaxId,
    //     taxRate: 0,
    //     isClientWHTax: false,
    //     isScPwd: false,
    //     entityTypeId: null,
    //     warehouseId: null,
    //     buId: null,
    //     parentId: null,
    //     taskId: null,
    //     userId: null,
    //     // lists
    //     whList: [],
    //     buList: [],
    //     parentList: [],
    //     taskList: [],
    //     userList: [],
    //     itemId: null,
    //     entityTypeList: [
    //       { id: 2, name: 'Business Unit' },
    //       { id: 4, name: 'Warehouse' },
    //       { id: 3, name: 'Engagement' },
    //       { id: 1, name: 'Project' },
    //     ],
    //     inventoryAssetAccountId: null,
    //     purchaseAccountId: null,
    //     costPrice: null,
    //   };
    //
    //   this.form.serviceRevenue2.push(itm)
    //   return row
    // },
    removeItem(table, index){
      this.form[table] = this.form[table].filter((val, i) => i !== index)
    },
    // removeItem2(index) {
    //   this.form.serviceRevenue2 = this.form.serviceRevenue2.filter((val, i) => i !== index)
    // },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    async add(id) {
      if (this.form.typeOfSale !== 'isBoth') {
        if (!this.form.generalSwitch && !this.form.salesDirectToMiscellaneous && !this.form.salesDirectToNonRevenueAccount) {
          this.$message({
            message: 'Fill in at least one table',
            type: 'warning'
          });
          return
        }
      }

      let modePmValid = false
      let table1Valid = true
      let table2Valid = true
      let table3Valid = true
      let table4Valid = true
      switch (this.form.modeOfPayment) {
        case 1:
          modePmValid = await this.$refs.singlePM.validate()
          break
        case 2:
          modePmValid = await this.$refs.splitPM.validate()
          break
        case 3:
          break
        case 4:
          break
      }

      // validate 1 table
      if (this.form.generalSwitch && this.$refs['crServiceRevenue']) {
        const table1 = this.$refs['crServiceRevenue'].$refs.form
        table1.validate(async (valid) => {
          table1Valid = valid
        })
      }

      // validate 2 table
      if (this.form.salesDirectToMiscellaneous && this.$refs['crServiceRevenue2']) {
        const table2 = this.$refs['crServiceRevenue2'].$refs.form
        table2.validate(async (valid) => {
          table2Valid = valid
        })
      }

      // validate 3 table
      if (this.form.salesDirectToNonRevenueAccount && this.$refs['salesDirectToNonRevenues']) {
        const table3 = this.$refs['salesDirectToNonRevenues'].$refs.form
        table3.validate(async (valid) => {
          table3Valid = valid
        })
      }

      // validate 4 table
      if (this.form.typeOfSale === 'isBoth' && this.$refs['crSalesServiceItems']) {
        const table4 = this.$refs['crSalesServiceItems'].$refs.form
        table4.validate(async (valid) => {
          table4Valid = valid
        })
      }

      console.log('===', modePmValid, table1Valid, table2Valid, table3Valid, table4Valid)

      this.$refs['form'].validate(async (valid) => {
        try {
          if (valid && modePmValid && table1Valid && table2Valid && table3Valid && table4Valid) {
            let loader = this.$loading.show()
            const header = await this.headerRequest(id)
            this.disabledForm = true
            this.updatedState = false
            await this.createCashReceipt(header)
            await this.createCashReceiptDetail(header)
            await this.createCashReceiptUseBalance(header)
            await this.createCashReceiptTransaction(header)
            if (this.imgPreview) {
              await this.createFile(header, this.imgPreview)
            }
            loader.hide()
            console.log('===', id, header)
            if (!id && header) {
              this.$router.push(`/cash-receipts/${header.id}?companyId=${this.$route.query.companyId}`)
            }
          }
        } catch (err) {
          console.log(err)
        }
      })
    },
    async addAndNew(id) {
      if (!this.form.generalSwitch && !this.form.salesDirectToMiscellaneous && !this.form.salesDirectToNonRevenueAccount) {
        this.$message({
          message: 'Fill in at least one table',
          type: 'warning'
        });
        return
      }

      let modePmValid = false
      let table1Valid = true
      let table2Valid = true
      let table3Valid = true
      let table4Valid = true
      switch (this.form.modeOfPayment) {
        case 1:
          modePmValid = await this.$refs.singlePM.validate()
          break
        case 2:
          modePmValid = await this.$refs.splitPM.validate()
          break
        case 3:
          break
        case 4:
          break
      }

      // validate 1 table
      if (this.form.generalSwitch && this.$refs['crServiceRevenue']) {
        const table1 = this.$refs['crServiceRevenue'].$refs.form
        table1.validate(async (valid) => {
          table1Valid = valid
        })
      }

      // validate 2 table
      if (this.form.salesDirectToMiscellaneous && this.$refs['crServiceRevenue2']) {
        const table2 = this.$refs['crServiceRevenue2'].$refs.form
        table2.validate(async (valid) => {
          table2Valid = valid
        })
      }

      // validate 3 table
      if (this.form.salesDirectToNonRevenueAccount && this.$refs['salesDirectToNonRevenues']) {
        const table3 = this.$refs['salesDirectToNonRevenues'].$refs.form
        table3.validate(async (valid) => {
          table3Valid = valid
        })
      }

      // validate 4 table
      if (this.form.typeOfSale === 'isBoth' && this.$refs['crSalesServiceItems']) {
        const table3 = this.$refs['crSalesServiceItems'].$refs.form
        table3.validate(async (valid) => {
          table4Valid = valid
        })
      }

      console.log('===', modePmValid, table1Valid, table2Valid)

      this.$refs['form'].validate(async (valid) => {
        try {
          if (valid && modePmValid && table1Valid && table2Valid) {
            let loader = this.$loading.show()
            this.disabledForm = true
            this.updatedState = false
            const header = await this.headerRequest(id)

            await this.createCashReceipt(header)
            await this.createCashReceiptDetail(header)
            await this.createCashReceiptUseBalance(header)
            await this.createCashReceiptTransaction(header)
            // Object.assign(this.$data, this.initialData())
            // this.$refs['crServiceRevenue'].$refs['form'].resetFields()
            if (this.form.generalSwitch) this.$refs['crServiceRevenue'].$refs['form'].resetFields()
            if (this.form.salesDirectToMiscellaneous) this.$refs['crServiceRevenue2'].$refs['form'].resetFields()
            if (this.form.salesDirectToNonRevenueAccount) this.$refs['salesDirectToNonRevenues'].$refs['form'].resetFields()
            if (this.form.typeOfSale === 'isBoth') this.$refs['crSalesServiceItems'].$refs['form'].resetFields()
            if (this.form.modeOfPayment === 1) this.$refs['singlePM'].$refs['form'].resetFields()
            if (this.form.modeOfPayment === 2) this.$refs['splitPM'].$refs['form'].resetFields()
            this.$refs['form'].resetFields()
            loader.hide()
            this.disabledForm = false
            this.updatedState = true
            this.isBlock = false
            // console.log('===', id, header)
            // if (!id && header) {
            //   this.$router.push(`/cash-receipts/${header.id}?companyId=${this.$route.query.companyId}`)
            // }
          }
        } catch (err) {
          console.log(err)
        }
      })
    },
    async checked(id) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/cashReceipt/check?transactionId=${this.form.transactionId}&cashReceiptHeaderId=${this.$route.params.id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}`)
        this.notification("Success", "Cash Receipts Checked", "success");
        loader.hide()
        await this.init()
      } catch (err) {
        loader.hide()
      }
    },
    async sendToAccountant(id) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/cashReceipt/send-to-accountant?transactionId=${this.form.transactionId}&companyId=${this.$route.query.companyId}&tab=cashReceipts&transactionNo=${this.transactionNo}&cashReceiptHeaderId=${this.$route.params.id}`)
        this.notification("Success", "", "success");
        loader.hide()
        await this.init()
      } catch (err) {
        loader.hide()
      }
    },
    voidCashReceipt(id) {
      this.$confirm('Do you want to Void current Cash Receipt?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'info'
      }).then(async () => {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.get(`/api/v1/cashReceipt/void?cashReceiptHeaderId=${id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}&transactionId=${this.form.transactionId}`)
          this.notification("Success", "Void", "success");
          loader.hide()
          await this.init()
        } catch (err) {
          loader.hide()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Void canceled'
        });
      });
    },
    async deleteCashReceipt(id) {
      this.$confirm('Do you want to Delete current Cash Receipt?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'info'
      }).then(async () => {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.get(`/api/v1/cashReceipt/delete?cashReceiptHeaderId=${id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}&transactionId=${this.form.transactionId}`)
          this.notification("Success", "Cash Receipt deleted", "success");
          loader.hide()
          this.$router.push(`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=cashReceipts`)
        } catch (err) {
          loader.hide()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    async record(id) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/cashReceipt/post?cashReceiptHeaderId=${id}`)
        this.notification("Success", "Cash Receipt recorded", "success");
        loader.hide()
        await this.init()
      } catch (err) {
        loader.hide()
      }
    },
    async headerRequest(id) {
      try {
        const payload = {
          crDate: this.form.tranDate,
          clientId: this.form.clientId,
          clientTin: this.form.clientTin,
          typeOfBusiness: this.form.typeOfBusiness,
          paymentTerms: this.form.paymentTerms,
          serviceVATCode: this.form.serviceVATCode,
          productVATCode: this.form.productVATCode,
          clientCurrency: this.form.currency,
          paymentCurrency: this.form.paymentCurrency,
          fxRate: this.form.exchangeRate,
          whtaxRate: this.form.whTaxRate,
          vatWhtaxRate: this.form.vatWhtaxRate,
          isWHTax: Boolean(this.form.isWHTax),
          isWHTaxToggle: Boolean(this.form.isWHTaxSwitch),
          isVatWHTaxToggle: Boolean(this.form.isVatWHTaxSwitch),
          isUseBalanceToggle: Boolean(this.form.isUseBalance),
          isVatWHTax: Boolean(this.form.isVatWHTax),
          isSinglePayment: this.form.modeOfPayment === 1,
          isSplitPayment: this.form.modeOfPayment === 2,
          isClearingAccount: this.form.modeOfPayment === 3,
          isPDC: this.form.modeOfPayment === 4,
          receivedBy: this.form.receivedBy,
          forUser: this.form.forUser,
          isSDtoSRA: this.form.typeOfSale === 'isSDtoSRA',
          isSSI: this.form.typeOfSale === 'isSSI',
          isBoth: this.form.typeOfSale === 'isBoth',
          amountsAre: this.form.amountsAre,
          sellingNotes: this.form.sellingNotes,
          paymentFor: this.form.paymentFor,
          otherRevenueCharges: this.results.otherRevenueCharges,
          nonRevenueCharges: this.results.nonRevenueCharges, // TODO
          discount: this.results.discount, // TODO
          vatableAmount: this.results.vatableAmount,
          vatExAmount: this.results.vatExAmount,
          zeroRatedAmount: this.results.zeroRatedAmount,
          addVat: this.results.vatAmount,
          totalAmount: this.results.totalAmountVatInclusinve,
          amountVatExclusive: this.results.amountVatExcluded,
          addVatAmount: this.results.addVatAmount,
          totalAmountVatInclusive: this.results.totalAmountNoTax,
          lessVatWHTax: this.results.lessCreditableWithholdingVat,
          lessWHTax: this.results.lessCreditableWithholdingTax,
          amountOwing: this.results.amountOwing,
          amountReceived: this.results.receivedAmount,
          balanceOwing: this.results.balanceOwing,
          amountOwingClientCurrency: this.results.amountOwingClientCurrency,
          balanceOwingClientCurrency: this.results.balanceOwingClientCurrency,
          templateName: null, //TODO ???
          orNumber: null, //TODO ???,
          issueDate: null, //TODO ???,
          isEOR: false, //TODO ???
          isEN: false, //TODO ???
          isEL: false, //TODO ???
          clientContact: null, //TODO ???
          clientEmail: this.form.clientEmail,
          isSales: this.form.isSales,
          isDeposit: this.form.isDeposit,
          isAdvancesFrom: this.form.isAdvancesFrom,
          appliedUnderOverPMTBal: this.form.appliedUnderOverPMTBal, // TODO
          appliedDepositBal: 0, // TODO
          appliedCashAdvanceBal: 0, // TODO
        }

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.post(id ? `/api/v1/cashReceiptHeader/update?cashReceiptHeaderId=${id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}&transactionId=${this.form.transactionId}` : `/api/v1/cashReceiptHeader/create?companyId=${this.$route.query.companyId}`, payload)
        // const response = await axios.get(`/api/v1/cashReceipt/item?id=${data.id}`)
        // this.transactionNo = response.data.item.transaction.transactionNo
        this.notification("Success", id ? "Cash Receipts updated" : "Cash Receipts added", "success");
        return data
      } catch (err){
        console.log(err)
      }
    },
    async createCashReceipt(cashReceiptHeader) {
      try {
        const payload = {
          cashReceiptPaymentsList: []
        }

        let data = []
        switch (this.form.modeOfPayment) {
          case 1:
            data.push(this.$refs.singlePM.form)
            break
          case 2:
            data = this.$refs.splitPM.form.items.filter(val => Boolean(val.paymentMethodId))
            break
          case 3:

            break
          case 4:

            break
        }

        data.map(row => {
          const item = {
            cashReceiptHeaderId: cashReceiptHeader.id,
            // receivedDate: row.receivedDate,
            receivedDate: this.form.receivedDate,
            paymentMethodId: row.paymentMethodId,
            depositAccountId: row.depositAccountId,
            chequeRefNo: row.chequeRefNo,
            dateOfCheque: null,
            chequeIssueDate: null,
            chequeIssuedBy: null,
            amountReceived: row.amountReceived,
            balanceToReceived: this.form.modeOfPayment === 2 ? row.balanceToReceived : null, //TODO ???
            paymentStatus: null,
            foreignAmountReceived: null,
            paymentCurrency: null
          }
          payload.cashReceiptPaymentsList.push(item)
        })

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/cashReceiptPayment/create?companyId=${this.$route.query.companyId}`, payload)
      } catch (err) {
        console.log(err)
      }
    },
    async createCashReceiptDetail(cashReceiptHeader) {
      try {
        const payload = {
          cashReceiptDetailsList: []
        }

        let table = []
        if (this.form.generalSwitch) {
          table = [...this.form.serviceRevenue]
        }
        if (this.form.salesDirectToMiscellaneous) {
          table = [...table, ...this.form.serviceRevenue2.map(val => ({ ...val, isOtherRevenue: true }))]
        }
        // let table = this.form.salesDirectToMiscellaneous ? [...this.form.serviceRevenue, ...this.form.serviceRevenue2.map(val => ({ ...val, isOtherRevenue: true }))] : [...this.form.serviceRevenue]
        if (this.form.salesDirectToNonRevenueAccount) {
          table = [...table, ...this.form.salesDirectToNonRevenues.map(val => ({ ...val, isNonRevenue: true }))]
        }
        if (this.form.typeOfSale === 'isBoth') {
          table = [...table, ...this.form.salesServiceItems]
        }
        // console.log('RRRRRRRRRKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK', table)
        if (!this.form.isVatWHTaxSwitch && this.applyVatWHTaxObj) table.push(this.applyVatWHTaxObj)
        if (!this.form.isWHTaxSwitch && this.applyWHTaxObj) table.push(this.applyWHTaxObj)
        for (let i = 0; i < table.length; i++) {
          const vatableAmount = await this.countVatableAmount([table[i]], this.form.amountsAre)
          const vatAmount = await this.countWTax(vatableAmount, table[i].taxRate)
          const item = {
            cashReceiptHeaderId: cashReceiptHeader.id,
            accountNumber: table[i].no,
            accountId: table[i].revenueAccount,
            details: table[i].description ? table[i].description : null,
            unitPrice: table[i].price,
            unitId: table[i].unit,
            isClientWHTax: !!table[i].isClientWHTax,
            qty: table[i].qty,
            typeTable: table[i].typeTable,
            totalAmount: table[i].totalAmount,
            taxCodeId: table[i].isClientWHTax ? table[i].revenueAccount : table[i].taxCode,
            taxRate: table[i].taxRate,
            vatableAmount,
            vatExemptAmount: this.salesTaxListExemptTax.id === table[i].taxCode ? table[i].totalAmount : 0,
            zeroRatedAmount: this.salesTaxListWithZeroRate.id === table[i].taxCode ? table[i].totalAmount : 0,
            vatAmount: table[i].isClientWHTax ? vatableAmount : vatAmount,
            notaxAmount: this.salesTaxListNoTaxSP.id === table[i].taxCode ? table[i].totalAmount : 0,
            allocatedTo: table[i].entityTypeId,
            buId: table[i].buId,
            whsengproId: table[i].parentId,
            taskId: table[i].taskId,
            euId: table[i].userId,
            isOtherRevenue: !!table[i].isOtherRevenue,
            itemId: table[i].itemId,
            warehouseId: table[i].warehouseId,
            inventoryAssetAccountId: table[i].inventoryAssetAccountId,
            purchaseAccountId: table[i].purchaseAccountId,
            costPrice: table[i].costPrice,
            discount: null, // TODO
            discountAccountId: table[i].discountAccountId, // TODO
            isNonRevenue: !!table[i].isNonRevenue, // TODO
          }
          if (this.form.typeOfSale === 'isSSI') {
            const account = this.accountsRevenue.find(val => val.id === table[i].itemId)
            if (account && account.sellAccount) {
              item.accountId = account.sellAccount.id
              // item.itemId = table[i].revenueAccount
            } else {
              // item.accountId = null
              // item.itemId = table[i].revenueAccount
            }
          }
          if (this.form.typeOfSale === 'isBoth') {
            const account = this.accountsRevenueSales.find(val => val.id === table[i].itemId)
            if (account && account.sellAccount) {
              item.accountId = account.sellAccount.id
              // item.itemId = table[i].revenueAccount
            } else {
              // item.accountId = null
              // item.itemId = table[i].revenueAccount
            }
          }
          payload.cashReceiptDetailsList.push(item)
        }

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/cashReceiptDetail/create?companyId=${this.$route.query.companyId}`, payload)
      } catch (err) {
        console.log(err)
      }
    },
    async reverse() {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/cashReceipt/reverse?cashReceiptHeaderId=${this.$route.params.id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}`)
        this.notification("Success", "", "success");
        loader.hide()
        await this.init()
      } catch (err) {
        loader.hide()
      }
    },
    openModalHistory() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/cashReceipt/history?companyId=${this.$route.query.companyId}&transactionId=${this.form.transactionId}`)
          .then(response => {
            console.log('response', response)
            this.$refs.openHistory.openModal()
            this.historyList = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    async createCashReceiptTransaction(cashReceiptHeader) {
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const response = await axios.get(`/api/v1/cashReceiptTransaction/create?cashReceiptHeaderId=${cashReceiptHeader.id}&companyId=${this.$route.query.companyId}`)
        this.form.transactionId = response.data.transactionId
      } catch (err) {
        console.log(err)
      }
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    async changeAmountsAre(val) {
      if (val === 4) {
        this.form.serviceRevenue = this.form.serviceRevenue.map(item => ({...item, taxCode: null, taxRate: 0 }))
        this.form.serviceRevenue2 = this.form.serviceRevenue2.map(item => ({...item, taxCode: null, taxRate: 0 }))
        this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: null, taxRate: 0 }))
        this.form.salesDirectToNonRevenues = this.form.salesDirectToNonRevenues.map((item) => ({...item, taxCode: null, taxRate: 0 }))
      }
      if (val === 1) {
        if (this.salesTaxListNoTaxSP) {
          this.form.serviceRevenue = this.form.serviceRevenue.map(item => ({...item, taxCode: this.salesTaxListNoTaxSP.id, taxRate: 0 }))
          this.form.serviceRevenue2 = this.form.serviceRevenue2.map(item => ({...item, taxCode: this.salesTaxListNoTaxSP.id, taxRate: 0 }))
          this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: this.salesTaxListNoTaxSP.id, taxRate: 0 }))
          this.form.salesDirectToNonRevenues = this.form.salesDirectToNonRevenues.map((item) => ({...item, taxCode: this.salesTaxListNoTax.id, taxRate: 0 }))
        } else {
          this.$alert(`Missed "No Tax" for Sales! Please Go to settings, select Tax libraries and activate NT Sales`, 'Warning', {
            confirmButtonText: 'OK',
            type: 'info',
            callback: action => {
              console.log(action)
            }
          });
        }
      }
      await this.setTaxCodeToTable()
      await this.calculateResults()
    },
    async calculateResults() {
      await this.$nextTick()
      this.results = initResults()

      let discountList, serviceRevenueNotDiscount
      if (this.form.typeOfSale === 'isSSI') {
        discountList = []
        serviceRevenueNotDiscount = this.form.serviceRevenue
      } else {
        discountList = await this.getDiscountList(this.form.serviceRevenue)
        serviceRevenueNotDiscount = await this.getNotDiscountList(this.form.serviceRevenue)
      }
      console.log("🚀 ~ calculateResults ~ serviceRevenueNotDiscount:", serviceRevenueNotDiscount)

      let table = this.form.salesDirectToMiscellaneous ? [...serviceRevenueNotDiscount, ...this.form.serviceRevenue2] : [...serviceRevenueNotDiscount]
      if (this.form.salesDirectToNonRevenueAccount) {
        table = [...table, ...this.form.salesDirectToNonRevenues]
      }
      if (this.form.typeOfSale === 'isBoth') {
        table = [...table, ...this.form.salesServiceItems]
      }
      let discountTotalTaxAmountFromTable = await this.countTotalTaxAmountTable(discountList, this.form.amountsAre)
      this.results.totalAmountFromTable = await this.countTotalAmountTable(table)
      this.results.totalTaxAmountFromTable = await this.countTotalTaxAmountTable(table, this.form.amountsAre) - discountTotalTaxAmountFromTable

      if (this.form.amountsAre === 3) {
        this.results.otherRevenueCharges = await this.countVatableAmount(this.form.serviceRevenue2, this.form.amountsAre)
        this.results.nonRevenueCharges = await this.countVatableAmount(this.form.salesDirectToNonRevenues, this.form.amountsAre)
      } else {
        this.results.otherRevenueCharges = await this.countTotalAmountTable(this.form.serviceRevenue2)
        this.results.nonRevenueCharges = await this.countTotalAmountTable(this.form.salesDirectToNonRevenues)
      }

      // discount
      this.results.discount = await this.countTotalAmountTable(discountList)
      let discountVatExAmount = await this.countVatExAmount(discountList)
      let discountZeroRatedAmount = await this.countZeroRatedAmount(discountList)
      let discountNoTaxAmount = await this.countNoTaxAmount(discountList)

      // Сума дискаунта без 2х типов
      let discountVatableAmount = await this.countVatableAmount(discountList, this.form.amountsAre)
      // Table only VATableAmount
      let discountTableForVATableAmount = await this.discountCountTotalTaxAmountTable(discountList, this.form.amountsAre)


      if (this.form.amountsAre === 2 || this.form.amountsAre === 3) {
        this.results.vatableAmount = await this.countVatableAmount(table, this.form.amountsAre) - await this.countVatableAmount(discountList, this.form.amountsAre)
      } else {
        this.results.vatableAmount = await this.countVatableAmount(table, this.form.amountsAre)
      }
      this.results.vatExAmount = await this.countVatExAmount(table) - discountVatExAmount
      this.results.zeroRatedAmount = await this.countZeroRatedAmount(table) - discountZeroRatedAmount
      this.results.noTaxAmount = await this.countNoTaxAmount(table)
      // if (this.form.amountsAre === 2 || this.form.amountsAre === 3) {
      //   this.results.vatableAmount = await this.countVatableAmount(table, this.form.amountsAre)
      // }

      // TODO VAT Amount
      this.results.vatAmount = this.results.totalTaxAmountFromTable

      // TODO Total Amount (VAT Inclusive)
      this.results.totalAmountVatInclusinve = (this.results.vatableAmount + this.results.vatExAmount + this.results.zeroRatedAmount + this.results.vatAmount)



      switch(this.form.modeOfPayment) {
        case 1:
          // TODO Received Amount
          this.results.receivedAmount = await this.countReceivedAmount(this.$refs.singlePM.form.amountReceived)
          break
        case 2:
          // TODO Received Amount
          this.results.receivedAmount = await this.countReceivedAmount(this.$refs.splitPM.form.items.reduce(
              (accumulator, currentValue) => accumulator + currentValue.amountReceived,
              0
          ))
          break
      }

      // TODO No Tax
        // TODO Amount (No Tax)
        if (this.form.amountsAre === 2 || this.form.amountsAre === 3) {
          this.results.amountVatExcluded = this.results.totalAmountVatInclusinve - this.results.vatAmount + this.results.noTaxAmount - discountNoTaxAmount
        } else {
          this.results.amountVatExcluded = this.results.totalAmountFromTable - this.results.discount
        }

        if (this.form.amountsAre === 2 || this.form.amountsAre === 3) {
          this.results.addVatAmount = this.results.vatAmount
        }

        this.results.lessCreditableWithholdingTax = await this.countWTax(this.results.amountVatExcluded, this.form.whTaxRate)
        // is toggle switch
        if (this.form.isWHTaxSwitch) {
          this.results.lessCreditableWithholdingTax = 0
        }
        if (this.form.amountsAre !== 1) {
          this.results.lessCreditableWithholdingVat = await this.countWTax(this.results.vatableAmount, this.form.vatWhtaxRate)
        }
        // is toggle switch
        if (this.form.isVatWHTaxSwitch) {
          this.results.lessCreditableWithholdingVat = 0
        }


        // TODO Less: Total Discounts
        this.results.lessTotalDiscounts = (this.results.lineDiscountsOffered + this.results.lumpsumDiscountsOffered + this.results.scPwdDiscount)
        // TODO Amount NET of Discounts
        this.results.amountNetOfDiscounts = this.results.amountVatExcluded - this.results.lessTotalDiscounts
        // TODO Total Amount (No Tax)
        this.results.totalAmountNoTax = this.results.amountNetOfDiscounts + this.results.addVatAmount

        // TODO Amount Owing
        this.results.amountOwing = this.results.totalAmountNoTax - (this.results.lessCreditableWithholdingTax + this.results.lessCreditableWithholdingVat)
        // this.form.modeOfPayment === 2 && this.calculateBalanceToReceived()
        if (this.form.appliedUnderOverPMTBal > 0) {
          this.results.amountOwing = this.results.amountOwing - this.form.appliedUnderOverPMTBal
        }
        // TODO Balance Owing
        this.results.balanceOwing = this.results.amountOwing - this.results.receivedAmount
      console.log('this.results.amountOwing', this.results.amountVatExcluded, this.form.whTaxRate)

      if (this.results.balanceOwing > 0) {
        this.results.underPayment = Math.abs(this.results.balanceOwing)
        this.results.overPayment = 0
      } else if (this.results.balanceOwing < 0) {
        this.results.underPayment = 0
        this.results.overPayment = Math.abs(this.results.balanceOwing)
      } else {
        this.results.underPayment = 0
        this.results.overPayment = 0
      }

        if (this.form.currency && this.form.currency !== this.companyLayout.currency.code) {
          this.results.amountOwingClientCurrency = this.results.amountOwing * this.form.exchangeRate
          this.results.receivedAmountClientCurrency = this.results.receivedAmount * this.form.exchangeRate
          this.results.balanceOwingClientCurrency = this.results.balanceOwing * this.form.exchangeRate
          this.results.underPaymentClientCurrency = this.results.underPayment * this.form.exchangeRate
          this.results.overPaymentClientCurrency = this.results.overPayment * this.form.exchangeRate
        }

      this.form.modeOfPayment === 2 && this.calculateBalanceToReceived()


      if (this.form.applyVatWHTaxObj) {
          this.setApplyVatWHTaxObj()
        } else {
          this.applyVatWHTaxObj = null
        }

        if (this.form.applyWHTaxObj) {
          this.setApplyWHTaxObj()
        } else {
          this.applyWHTaxObj = null
        }
    },
    setApplyVatWHTaxObj() {
      this.applyVatWHTaxObj = {
        no: null,
        revenueAccount: this.form.applyVatWHTaxObj.id,
        description: `Linked tax account of ${this.form.applyVatWHTaxObj.name}`,
        price: 0,
        unit: null,
        qty: 1,
        scpwdDiscountRate: null,
        discountAmount: null,
        isClientWHTax: true,
        totalAmount: this.results.lessCreditableWithholdingVat,
        taxCode: null,
        taxRate: 0,
        isScPwd: false,
        entityTypeId: null,
        warehouseId: null,
        buId: null,
        parentId: null,
        taskId: null,
        userId: null,
        itemId: this.form.applyVatWHTaxObj.itemId,
        typeTable: 'serviceRevenue',
        discountAccountId: null,
        // lists
        whList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: [],
        inventoryAssetAccountId: null,
        purchaseAccountId: null,
        costPrice: null
      }
    },
    setApplyWHTaxObj() {
      this.applyWHTaxObj = {
        no: null,
        revenueAccount: this.form.applyWHTaxObj.id,
        description: `Linked tax account of ${this.form.applyWHTaxObj.name}`,
        price: 0,
        unit: null,
        qty: 1,
        scpwdDiscountRate: null,
        discountAmount: null,
        isClientWHTax: true,
        totalAmount: this.results.lessCreditableWithholdingTax,
        taxCode: null,
        taxRate: 0,
        isScPwd: false,
        entityTypeId: null,
        warehouseId: null,
        buId: null,
        parentId: null,
        taskId: null,
        userId: null,
        itemId: this.form.applyWHTaxObj.itemId,
        typeTable: 'serviceRevenue',
        discountAccountId: null,
        // lists
        whList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: [],
        inventoryAssetAccountId: null,
        purchaseAccountId: null,
        costPrice: null
      }
    },
    countTotalAmountTable(items) {
      return new Promise((resolve) => {
        const amount = items.reduce((accumulator, currentValue) => accumulator + currentValue.totalAmount, 0)
        resolve(amount)
      })
    },
    countTotalAmountTableDiscount(items) {
      return new Promise((resolve) => {
        const amount = items.reduce((accumulator, currentValue) => {
          const targetItem = this.accountsRevenue.find(item => item.id === currentValue.revenueAccount);
          if (targetItem) {
            if (targetItem.accountTypeId === 30) return accumulator + currentValue.totalAmount
          }
          return accumulator;
        }, 0)
        resolve(amount)
      })
    },
    getDiscountList(items) {
      return new Promise((resolve) => {
        const amount = items.filter((item) => {
          const targetItem = this.accountsRevenue.find(i => i.id === item.revenueAccount);
          if (!targetItem) return false
          if (targetItem.accountTypeId === 30) return true
          return false
        });
        resolve(amount)
      })
    },
    getNotDiscountList(items) {
      return new Promise((resolve) => {
        const amount = items.filter((item) => {
          const targetItem = this.accountsRevenue.find(i => i.id === item.revenueAccount);
          if (!targetItem) return false
          if (targetItem.accountTypeId !== 30) return true
          return false
        });
        resolve(amount)
      })
    },
    countTotalTaxAmountTable(items, amountsAre){
      return new Promise((resolve) => {
        let totalTaxAmountFromTable = 0
        switch(amountsAre) {
            // exclude
          case 2:
            for (let i = 0; i < items.length; i++) {
              totalTaxAmountFromTable = totalTaxAmountFromTable + +((+items[i].totalAmount * items[i].taxRate) / 100).toFixed(6)
            }
            break;
            // include
          case 3:
            for (let i = 0; i < items.length; i++) {
              totalTaxAmountFromTable = totalTaxAmountFromTable + +(+items[i].totalAmount / (1 + (items[i].taxRate/100))) * +(items[i].taxRate/100)
              // totalTaxAmountFromTable = totalTaxAmountFromTable + +(+items[i].totalAmount - ((+items[i].totalAmount * 100) / (100 + items[i].taxRate))).toFixed(6)
            }
            break
          default:
            return resolve(0)
        }
        console.log('totalTaxAmountFromTable', totalTaxAmountFromTable)
        resolve(totalTaxAmountFromTable)
      })
    },
    discountCountTotalTaxAmountTable(items, amountsAre){
      return new Promise((resolve) => {
        const filteredItems = items.filter(val => this.salesTaxListExemptTax && val.taxCode !== this.salesTaxListExemptTax.id && val.taxCode !== this.salesTaxListWithZeroRate.id && val.taxCode !== this.salesTaxListNoTax.id && val.taxCode !== this.salesTaxListNoTaxSP.id)
        let totalTaxAmountFromTable = 0
        switch(amountsAre) {
            // exclude
          case 2:
            for (let i = 0; i < filteredItems.length; i++) {
              totalTaxAmountFromTable = totalTaxAmountFromTable + +((+filteredItems[i].totalAmount * filteredItems[i].taxRate) / 100).toFixed(6)
            }
            break;
            // include
          case 3:
            for (let i = 0; i < filteredItems.length; i++) {
              totalTaxAmountFromTable = totalTaxAmountFromTable + +(+filteredItems[i].totalAmount / (1 + (filteredItems[i].taxRate/100))) * +(filteredItems[i].taxRate/100)
              // totalTaxAmountFromTable = totalTaxAmountFromTable + +(+items[i].totalAmount - ((+items[i].totalAmount * 100) / (100 + items[i].taxRate))).toFixed(6)
            }
            break
          default:
            return resolve(0)
        }
        console.log('totalTaxAmountFromTable', totalTaxAmountFromTable)
        resolve(totalTaxAmountFromTable)
      })
    },
    countLineTotalDiscountTable(items) {
      let discount = 0
      return new Promise((resolve) => {
        items.map(item => {
          console.log('item', item, +item.discountAmount)
          let lineDiscount = 0
          if (item.scpwdDiscountRate === 1) {
            lineDiscount = this.percentage(+item.discountAmount, +item.totalAmount)
          } else if (item.scpwdDiscountRate === 2) {
            lineDiscount = +item.discountAmount
          }
          discount = discount + lineDiscount
        })
        resolve(discount)
      })
    },
    countVatExAmount(items) {
      let vatExAmount = 0
      return new Promise((resolve) => {
        const vatExItems = items.filter(val => val.taxCode === this.salesTaxListExemptTax.id)
        vatExItems.map(item => {
          const vatableExAmountLine = Number((+item.totalAmount / (1 + (+item.taxRate / 100))).toFixed(6))
          vatExAmount = vatExAmount + vatableExAmountLine
        })
        resolve(vatExAmount)
      })
    },
    countZeroRatedAmount(items) {
      let vatExAmount = 0
      return new Promise((resolve) => {
        const vatExItems = items.filter(val => val.taxCode === this.salesTaxListWithZeroRate.id)
        vatExItems.map(item => {
          const vatableExAmountLine = Number((+item.totalAmount / (1 + (+item.taxRate / 100))).toFixed(6))
          vatExAmount = vatExAmount + vatableExAmountLine
        })
        resolve(vatExAmount)
      })
    },
    async countNoTaxAmount(items) {
      let noTaxAmount = 0
      const filteredItems = items.filter(val => this.salesTaxListNoTax.id === val.taxCode || this.salesTaxListNoTaxSP.id === val.taxCode)
      noTaxAmount = await this.countTotalAmountTable(filteredItems)
      return +noTaxAmount
    },
    async countReceivedAmount(amount) {
      if (this.form.paymentCurrency === this.companyLayout.currency.code && this.form.exchangeRate) {
        return +(amount / this.form.exchangeRate)
      }
      return amount
    },
    countVatableAmount(items, amountsAre) {
      let vatableAmount = 0
      return new Promise((resolve) => {
        const filteredItems = items.filter(val => this.salesTaxListExemptTax && val.taxCode !== this.salesTaxListExemptTax.id && val.taxCode !== this.salesTaxListWithZeroRate.id && val.taxCode !== this.salesTaxListNoTax.id && val.taxCode !== this.salesTaxListNoTaxSP.id)
        switch (amountsAre) {
          // tax including
          case 3:
            filteredItems.map(item => {
              const vatableAmountLine = Number((+item.totalAmount / (1 + (+item.taxRate / 100))))
              vatableAmount = vatableAmount + vatableAmountLine
            })
            break;
            // tax exclusive
          case 2:
            filteredItems.map(item => {
              vatableAmount = vatableAmount + (+item.totalAmount)
            })
            break;

        }
        resolve(vatableAmount)
      })
    },
    discountCountVatableAmount(items, amountsAre) {
      let vatableAmount = 0
      return new Promise((resolve) => {
        const filteredItems = items.filter(val => this.salesTaxListExemptTax && val.taxCode !== this.salesTaxListExemptTax.id && val.taxCode !== this.salesTaxListWithZeroRate.id && val.taxCode !== this.salesTaxListNoTax.id && val.taxCode !== this.salesTaxListNoTaxSP.id)
        switch (amountsAre) {
          // tax including
          case 3:
            filteredItems.map(item => {
              const vatableAmountLine = Number((+item.totalAmount / (1 + (+item.taxRate / 100))))
              vatableAmount = vatableAmount + vatableAmountLine
            })
            break;
            // tax exclusive
          case 2:
            filteredItems.map(item => {
              vatableAmount = vatableAmount + (+item.totalAmount)
            })
            break;

        }
        resolve(vatableAmount)
      })
    },
    countWTax(amount, taxRate) {
      let result = 0
      return new Promise((resolve) => {
        result = amount * (taxRate / 100)
        resolve(result)
      })
    },
    percentage(percent, total) {
      return ((percent/ 100) * total) || 0
    },
    issueOfficialReceiptOpenModal() {
      this.$refs.issueOfficialReceiptModal.$refs.modal.open()
    },
    initialData() {
      return {
        listCRForUseBalance: [],
        form: {
          transactionId: null,
          paymentCurrency: null,
          // first row
          // col 1
          clientId: null,
          clientTin: null,
          typeOfBusiness: null,
          paymentTerms: null,
          serviceVATCode: null,
          productVATCode: null,
          // clientContactId: null,
          clientEmail: null,
          currency: null,
          tranDate: null,
          // tranDate: moment().format("MM-DD-YYYY"),
          isWHTax: false,
          isWHTaxSwitch: false,
          saleTaxId: null,
          applyWHTaxObj: null,
          whTaxRate: 0,
          isVatWHTax: false,
          isVatWHTaxSwitch: false,
          clResult: 0,
          clResultAfterRate: 0,
          applyVatWHTaxObj: null,
          vatWhtaxRate: 0,
          addedBy: null,
          forUser: null,
          // row 1
          isUseBalance: false,
          appliedUnderOverPMTBal: 0,
          // col 2
          modeOfPayment: 1,
          receivedBy: null,
          // second row
          paymentFor: '',
          typeOfSale: 'isSDtoSRA',
          sellingNotes: null,
          lumpsumDiscountRate: null,
          lumpsumDiscountAmount: null,
          addBillableTime: false,
          addBillableExpenses: false,
          allowDiscounts: 'noDiscount',
          amountsAre: 2,
          exchangeRate: 1,
          // table
          serviceRevenue: [{...itm, typeTable: 'serviceRevenue' }],
          salesServiceItems: [{...itm, typeTable: 'salesServiceItems'} ],
          serviceRevenue2: [{...itm, typeTable: 'serviceRevenue2' }],
          salesDirectToNonRevenues: [{...itm, typeTable: 'salesDirectToNonRevenues' }],
          generalSwitch: true,
          salesDirectToMiscellaneous: false,
          salesDirectToNonRevenueAccount: false,
          // third row
          template: null,
          officialReceiptNumber: 1,
          issueDate: null,
          receiptAdvice: null,
          createByFullName: '',
          isSales: true,
          isDeposit: false,
          isAdvancesFrom: false,
          receivedDate: null,
        },
        rules: {
          clientId: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          paymentCurrency: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          // clientContactId: [{
          //   required: true,
          //   message: this.$i18n.t('modal_settings_fieldIsRequired'),
          //   trigger: 'change'
          // }],
          receivedBy: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          exchangeRate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          forUser: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          sellingNotes: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          paymentFor: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          template: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          officialReceiptNumber: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          issueDate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          tranDate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          receivedDate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
        },
        modeOfPaymentList: [
          { id: 1, name: 'Single Payment (default)' },
          { id: 2, name: 'Split Payment' },
          // { id: 3, name: 'Use A Clearing Account' },
          // { id: 4, name: 'Receive Post Dated Cheques' },
        ],
        clientList: [],
        forUserList: [],
        paymentMethodList: [],
        depositAccountList: [],
        salesTaxList: [],
        templateList: [
          { id: 1, name: 'Template 1' }
        ],
        results: initResults(),
        // table list
        accountsRevenue: [],
        accountsRevenueSales: [],
        accountsNonRevenue: [],
        accountOthernRevenue: [],
        units: [],
        money: {
          precision: 2,
          decimal: '.',
          thousands: ',',
        },
        lumpsumDiscountRates: [
          { id: 1 , name: 'Percentage (%)' },
          { id: 2 , name: 'Amount ($)' }
        ],
        entityTypeList: [
          { id: 2, name: 'Business Unit' },
          { id: 4, name: 'Warehouse' },
          { id: 3, name: 'Engagement' },
          { id: 1, name: 'Project' },
        ],
        taxList: [
          {id: 1, name: 'No Tax'},
          {id: 2, name: 'Excluding Tax'},
          {id: 3, name: 'Including Tax'},
          {id: 4, name: 'Tax Exempt'},
        ],
        filesOpened: false,
        moment: moment,
        transaction: {},
        transactionNo: null,
        status: null,
        isBlock: false,
        disabledForm: false,
        updatedState: false,
        historyList: [],
        applyVatWHTaxObj: null,
        applyWHTaxObj: null,
        isSendToAcc: false,
        imgPreviewSrc: null,
        imgPreview: null,
        clientVendorDirectories: null,
        routeLoading: false
      }
    },
    async typeOfSaleChangeConfirm(val) {
      this.$confirm('If You change Type of Sale, all any entered will be removed. Client details will not be effected', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(async () => {
        let loader = this.$loading.show();
        try {
          this.form.typeOfSale = val
          this.form.serviceRevenue = this.initialData().form.serviceRevenue
          this.form.serviceRevenue2 = this.initialData().form.serviceRevenue2
          this.form.serviceRevenue = this.form.serviceRevenue.map(val => ({...val, revenueAccount: null, itemId: null }))
          this.form.serviceRevenue2 = this.form.serviceRevenue2.map(val => ({...val, revenueAccount: null, itemId: null }))
          await this.typeOfSaleChange(val)
          if (val === 'isSDtoSRA') {
            this.form.generalSwitch = true
            this.form.salesDirectToMiscellaneous = false
            this.form.salesDirectToNonRevenueAccount = false
          }
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }

      })
    },
    async typeOfSaleChange(val) {
      let loader = this.$loading.show();
      switch (val) {
        // case 'isSDtoSRA':
        //   try {
        //     const response = await axios.get(`/api/v1/cashReceipt/directories?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}`)
        //     this.accountsRevenue = response.data.directories.accountsRevenue
        //     this.accountOthernRevenue = response.data.directories.accountOthernRevenue
        //     loader.hide()
        //   } catch (err) {
        //     loader.hide()
        //     console.log(err)
        //   }
        //   break
        case 'isSSI':
            try {
              const response = await axios.get(`/api/v1/items/active-list?companyId=${this.$route.query.companyId}`)
              this.accountsRevenue = response.data.list.filter(val => val.sell)
              loader.hide()
            } catch (err) {
              loader.hide()
              console.log(err)
            }
          break
        case 'isBoth':
          try {
            const response = await axios.get(`/api/v1/items/active-list?companyId=${this.$route.query.companyId}`)
            this.accountsRevenueSales = response.data.list.filter(val => val.sell)
            const response2 = await axios.get(`/api/v1/cashReceipt/directories?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}`)
            this.accountsRevenue = response2.data.directories.accountsRevenue
            this.accountsNonRevenue = response2.data.directories.accountsNonRevenue
            this.accountOthernRevenue = response2.data.directories.accountOthernRevenue
            loader.hide()
          } catch (err) {
            loader.hide()
            console.log(err)
          }
          break
        default:
          try {
            const response = await axios.get(`/api/v1/cashReceipt/directories?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}`)
            this.accountsRevenue = response.data.directories.accountsRevenue
            this.accountsNonRevenue = response.data.directories.accountsNonRevenue
            this.accountOthernRevenue = response.data.directories.accountOthernRevenue
            loader.hide()
          } catch (err) {
            loader.hide()
            console.log(err)
          }
      }
    },
    handleFilePreview(e) {
      const file = e.target.files[0]
      if (file) {
        this.imgPreview = file
        this.imgPreviewSrc = URL.createObjectURL(file)
        this.filesOpened = true
      }
    },
    async itemImg(id) {
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/entityFiles/list?entityId=${id}&entityTypeId=84`)
        if (data.list.length) {
          this.imgPreviewSrc = data.list[0].url
        }
      } catch (err) {
        console.log(err)
      }
    },
    async createFile(cashReceiptHeader, fileObj) {
      let loader = this.$loading.show();
      try {
        const formData = new FormData();
        formData.append('file', fileObj);
        formData.append('entityId', this.form.transactionId);
        formData.append('entityTypeId', 84);
        formData.append('oldParentId', null);
        formData.append('taskId', null);
        formData.append('convert', 'false')
        formData.append('historyEntityId', this.form.transactionId);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    addClientOpenModal(){
      this.$refs['modal11'].openModal()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=client&countryId=${this.companyLayout.currency.id}`)
          .then(response => {
            this.clientVendorDirectories = response.data.list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
    },
    async selectClient(id) {
      try {
        this.form.clientId = id
        await this.directories()
        await this.changeClient(id)
      } catch (err) {
        console.log(err)
      }
    },
    setReceiveFor(value) {
      switch (value) {
        case 'sales':
          this.form.isSales = true
          this.form.isDeposit = false
          this.form.isAdvancesFrom = false
          break
        case 'deposits':
          this.form.isSales = false
          this.form.isDeposit = true
          this.form.isAdvancesFrom = false
          break
        case 'others':
          this.form.isSales = false
          this.form.isDeposit = false
          this.form.isAdvancesFrom = true
          break
        default:
          this.form.isSales = false
          this.form.isDeposit = false
          this.form.isAdvancesFrom = false
      }
    },
    appliedUnderOverPMTChange(e){
      console.log('====____', e)
      if ((this.form.appliedUnderOverPMTBal > this.form.clResult) && this.form.isUseBalance) {
        this.form.appliedUnderOverPMTBal = this.form.clResult
      }
      this.calculateResults()
    },
    openJournalModal() {
      const rowItem = {...this.transaction}
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry(rowItem)
    }
  },
  watch: {
    'form.serviceRevenue': {
      handler() {
        this.calculateResults()
      },
      deep: true
    },
    'form.serviceRevenue2': {
      handler() {
        this.calculateResults()
      },
      deep: true
    },
    'form.salesDirectToNonRevenues': {
      handler() {
        this.calculateResults()
      },
      deep: true
    },
    'form.salesServiceItems': {
      handler() {
        this.calculateResults()
      },
      deep: true
    },
    async '$route'(to, from){
      this.routeLoading = true
      this.paymentMethodList = []
      Object.assign(this.$data, this.initialData())
      await this.init()
      // this.routeLoading = false
      // this.$refs['crServiceRevenue'].$refs['form'].resetFields()
      // this.$nextTick(() => {
      //   if (this.$refs['crServiceRevenue']) this.$refs['crServiceRevenue'].$refs['form'].resetFields()
      //   if (this.$refs['crServiceRevenue2']) this.$refs['crServiceRevenue2'].$refs['form'].resetFields()
      //   if (this.$refs['salesDirectToNonRevenues']) this.$refs['salesDirectToNonRevenues'].$refs['form'].resetFields()
      //   if (this.$refs['crSalesServiceItems']) this.$refs['crSalesServiceItems'].$refs['form'].resetFields()
      //   if (this.$refs['singlePM']) this.$refs['singlePM'].$refs['form'].resetFields()
      //   if (this.$refs['splitPM']) this.$refs['splitPM'].$refs['form'].resetFields()
      //   this.$refs['form'].resetFields()
      //
      // })
    }
  }
}

const initResults = () => {
  return {
    // first column
    lineDiscountsOffered: 0, // TODO No Tax
    lumpsumDiscountsOffered: 0, // TODO No Tax
    scPwdDiscount: 0, // TODO No Tax
    otherRevenueCharges: 0, // TODO No Tax
    nonRevenueCharges: 0,
    discount: 0,
    vatableAmount: 0, // TODO No Tax
    vatExAmount: 0, // TODO Tax Exempt
    zeroRatedAmount: 0, // TODO No Tax
    noTaxAmount: 0,
    vatAmount: 0, // TODO No Tax
    addVat: 0,
    totalAmount: 0,
    // second column
    amountVatExcluded: 0, // TODO No Tax
    lessTotalDiscounts: 0, // TODO No Tax
    amountNetOfDiscounts: 0, //TODO No Tax
    totalAmountNoTax: 0, //TODO No Tax
    lessCreditableWithholdingVat: 0, // TODO Tax Exempt
    lessCreditableWithholdingTax: 0, //TODO No Tax
    lessSCPWDDiscount: 0,
    addVatAmount: 0, //TODO No Tax
    totalAmountVatInclusinve: 0, //TODo No Tax
    amountNetVat: 0,
    lessWHTax: 0,
    lessVatWHTax: 0,
    amountOwing: 0, //TODO No Tax
    receivedAmount: 0, // TODO No Tax
    balanceOwing: 0, // TODO No Tax
    overPayment: 0,
    underPayment: 0,
    // third column
    amountOwingClientCurrency: 0,
    receivedAmountClientCurrency: 0,
    balanceOwingClientCurrency: 0,
    underPaymentClientCurrency: 0,
    overPaymentClientCurrency: 0,
    // hidden results
    totalAmountFromTable: 0,
    totalTaxAmountFromTable: 0,
    totalDiscountFromTable: 0
  }
}

 </script>

<style lang="scss" scoped>
.checkbox__title {
  display: inline-block;
  width: 18px;
  margin-left: 10px;
  font-weight: bold;
  color: #F56C6C;
  &_yes {
    color: #67C23A;
  }
}

.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      .settings-header {
        text-align: left;
        justify-content: space-between;
        display: flex;
        .tf-link {
          font-weight: 400;
          color: #409EFF;
          font-size: 16px;
        }
      }
      .select {
        width: 100%;
      }
      .form {
        display: flex;
        flex-direction: column;
        gap: 30px;
        .card {
          position: relative;
          .right-corner {
            position: absolute;
            top: 10px;
            right: 10px;
            display: flex;
            gap: 20px;
            &__badge {
              border: 1px solid black;
              padding: 10px 20px;
            }
          }
          .t-title {
            margin-bottom: 10px;
          }
          .radio-group-col {
            display: flex;
            gap: 5px;
            flex-direction: column;
          }
          &.card-2 {
            .t-textarea {
              /deep/ textarea {
                max-width: 500px;
                width: 100%;
              }
            }
            .t-switch {
              width: 200px;
              display: flex;
              justify-content: space-between;
            }
          }
          &.card-3 {
            .price-wrapper {
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
              width: fit-content;
              gap: 20px;
              float: right;
              .item {
                font-size: 14px;
                display: flex;
                justify-content: space-between;
                min-width: 260px;
                padding: 6px;
                margin-bottom: 10px;
                border: 1px solid #a9a9b0;
                &.orange {
                  background-color: #f5dab1;
                  width: 220px;
                  min-width: 220px;
                  margin-left: auto;
                }
                &.success {
                  background-color: #e1f3d8;
                }
                &.grey {
                  background-color: #ebeef5;
                }
                &.bold {
                  font-weight: bold;
                }
                &.dots {
                  border: 1px dashed #a9a9b0;
                }
                &.prices {
                  align-items: center;
                  justify-content: center;
                  text-align: center;
                  min-width: 100px;
                }
              }
            }
          }
          .transaction-no {
            font-weight: bold;
            color: rgb(64, 158, 255);
            cursor: pointer;
            // &:hover {
            //   text-decoration: underline;
            // }
          }
        }
        .source-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .source {
            display: flex;
            gap: 30px;
            align-items: center;
          }
          .tf-icon {
            font-size: 24px;
            cursor: pointer;
          }
        }
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

.payment-data {
  margin-top: 150px;
}

/deep/.v-money {
  height: 28px;
  line-height: 28px;
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border: none;
  border-bottom: 2px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px 0 0;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
/deep/.label-without-start {
  :before {
    display: none;
  }
}

/deep/.el-form-item__label:before {
  display: none;
}
</style>

<style lang="scss">
.el-date-editor.el-input {
  width: 100%;
}
</style>